(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ero-collection"] && !Shopify.designMode) return;
  try {
    
/*
  ERO Collection (Shop All) - selector state only.

  This module deliberately performs NO cart work. Every ATC on the page is a
  real <form> that assets/ero-cart.js hijacks (its ATC_FORMS selector carries
  .ero-collection__form), so the add request, the busy state, the ADDED!
  label swap, the error node and the drawer open all come from the one shared
  cart client. Writing a second one here is what the cart conventions forbid.
*/
(function () {
  'use strict';

  var ARMED = 'data-ero-collection-armed';

  function setPressed(button, on) {
    button.classList.toggle('is-selected', on);
    button.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  /* Pointer Events only. pointerdown arms, pointercancel disarms, and the
     activation handler is click so keyboard reaches it unchanged. */
  function bindActivate(button, run) {
    button.addEventListener('pointerdown', function () {
      button.setAttribute(ARMED, '');
    });
    button.addEventListener('pointercancel', function () {
      button.removeAttribute(ARMED);
    });
    button.addEventListener('click', function () {
      button.removeAttribute(ARMED);
      if (button.disabled) return;
      run();
    });
  }

  function initElevate(root) {
    var card = root.querySelector('[data-ero-collection-elevate]');
    if (!card) return;

    var tiles = Array.prototype.slice.call(card.querySelectorAll('[data-ero-collection-tile]'));
    var zone = card.querySelector('[data-ero-collection-zone]');
    var zoneImg = card.querySelector('[data-ero-collection-zone-img]');
    var priceNode = card.querySelector('[data-ero-collection-elevate-price]');
    var variantInput = card.querySelector('[data-ero-collection-variant-input]');
    var ratingRow = card.querySelector('[data-ero-collection-rating-row]');
    var ratingValue = card.querySelector('[data-ero-collection-rating-value]');
    var starClips = Array.prototype.slice.call(card.querySelectorAll('[data-ero-collection-star-clip]'));
    var RATING_FALLBACK = 4.9;
    var ratingToken = 0;

    function paintRating(value) {
      var rating = Math.max(0, Math.min(5, Number(value) || 0));
      var text = rating.toFixed(1);
      if (ratingValue) ratingValue.textContent = text;
      if (ratingRow) ratingRow.setAttribute('aria-label', 'Rated ' + text + ' out of 5');
      starClips.forEach(function (rect, index) {
        var fill = Math.max(0, Math.min(1, rating - index));
        var width = fill >= 1 ? 14 : (fill <= 0 ? 0 : 1.6 + 10.8 * fill);
        rect.setAttribute('width', String(Math.round(width * 1000) / 1000));
      });
    }

    // Bundle tile carries both flavor ids and gets the combined, rounded rating.
    function updateRating(tile) {
      var api = window.EroLoox;
      var ids = String(tile.getAttribute('data-loox-ids') || '').split(',').filter(Boolean);
      var token = ++ratingToken;
      var request = api && typeof api.ratingFor === 'function' ? api.ratingFor(ids) : Promise.resolve(null);
      request.then(function (result) {
        if (token !== ratingToken) return;
        paintRating(result ? result.rating : RATING_FALLBACK);
        if (ratingRow) ratingRow.classList.remove('is-rating-pending');
      });
    }
    if (!tiles.length) return;

    tiles.forEach(function (tile) {
      bindActivate(tile, function () {
        tiles.forEach(function (other) {
          setPressed(other, other === tile);
        });
        updateRating(tile);

        var price = tile.getAttribute('data-price');
        if (priceNode && price) priceNode.textContent = price;

        var variantId = tile.getAttribute('data-variant-id');
        if (variantInput && variantId) variantInput.value = variantId;

        /* Glow field colour follows the selector, using the buy box's
           per-flavour accents: cyan, peach, purple. */
        var glowRgb = tile.getAttribute('data-glow-rgb');
        if (zone && glowRgb) zone.style.setProperty('--ero-collection-glow-rgb', glowRgb);

        if (zoneImg) {
          var src = tile.getAttribute('data-zone-src');
          var srcset = tile.getAttribute('data-zone-srcset');
          var alt = tile.getAttribute('data-zone-alt');
          if (src) zoneImg.src = src;
          if (srcset) zoneImg.srcset = srcset;
          if (alt) zoneImg.alt = alt;
        }
      });
    });

    var startTile = tiles.filter(function (tile) {
      return tile.getAttribute('aria-pressed') === 'true' || tile.classList.contains('is-selected');
    })[0] || tiles[0];

    /* This module inits at readyState 'interactive', and Shopify's compiled
       section scripts run BEFORE assets/ero-loox.js (deferred at the end of
       body), so EroLoox may not exist yet. The row goes pending now, and the
       first paint waits for DOMContentLoaded, which fires after every
       deferred script. If EroLoox never arrives the row shows the fallback. */
    function startRating() {
      if (window.EroLoox) {
        updateRating(startTile);
      } else if (ratingRow) {
        ratingRow.classList.remove('is-rating-pending');
      }
    }

    if (ratingRow) {
      ratingRow.classList.add('is-rating-pending');
      window.setTimeout(function () { ratingRow.classList.remove('is-rating-pending'); }, 2500);
    }
    if (window.EroLoox || document.readyState === 'complete') {
      startRating();
    } else {
      document.addEventListener('DOMContentLoaded', startRating, { once: true });
    }
  }

  function initAccessory(card) {
    var chips = Array.prototype.slice.call(card.querySelectorAll('[data-ero-collection-chip]'));
    if (!chips.length) return;

    var photo = card.querySelector('[data-ero-collection-acc-img]');
    var colorNode = card.querySelector('[data-ero-collection-acc-color]');
    var priceNode = card.querySelector('[data-ero-collection-acc-price]');
    var variantInput = card.querySelector('[data-ero-collection-variant-input]');

    chips.forEach(function (chip) {
      bindActivate(chip, function () {
        chips.forEach(function (other) {
          setPressed(other, other === chip);
        });

        var title = chip.getAttribute('data-variant-title');
        if (colorNode && title) colorNode.textContent = title;

        var price = chip.getAttribute('data-variant-price');
        if (priceNode && price) priceNode.textContent = price;

        var variantId = chip.getAttribute('data-variant-id');
        if (variantInput && variantId) variantInput.value = variantId;

        /* The photo carries a srcset, and a srcset wins over src, so the
           swap has to write both or nothing changes. */
        var image = chip.getAttribute('data-variant-image');
        var imageSrcset = chip.getAttribute('data-variant-srcset');
        if (photo && image) {
          photo.src = image;
          if (imageSrcset) photo.srcset = imageSrcset;
        }
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.eroCollectionInit === '1') return;
    root.dataset.eroCollectionInit = '1';

    initElevate(root);
    Array.prototype.slice
      .call(root.querySelectorAll('[data-ero-collection-acc]'))
      .forEach(initAccessory);
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-ero-collection]')).forEach(init);
  }

  /* The theme editor re-renders the section wrapper, which hands back fresh
     nodes with no listeners and no init flag. */
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    var root = event.target.querySelector('[data-ero-collection]');
    if (root) init(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-cp-application"]) return;
  try {
    
(function () {
  'use strict';

  const selector = '[data-section-type="ero-cp-application"]';
  const TIMEOUT_MS = 15000;

  function init(root) {
    if (root._eroCpApplicationCleanup) return;
    const startedAt = Date.now();
    const form = root.querySelector('[data-cp-form]');
    if (!form) return;
    const password = form.querySelector('[data-cp-password]');
    const confirmation = form.querySelector('[data-cp-password-confirmation]');
    const lightboxLinks = Array.from(form.querySelectorAll('[data-cp-lightbox]'));
    if (!password || !confirmation) return;
    const card = root.querySelector('.ero-cp-application__card');
    const title = form.querySelector('[data-cp-title]');
    const success = form.querySelector('[data-cp-success]');
    const status = form.querySelector('[data-cp-status]');
    const submitButton = form.querySelector('button[type="submit"]');
    const ctaLabel = form.querySelector('.ero-cp-application__cta-label');
    let sending = false;

    // The HTML request keeps novalidate="false" in markup. This reflected
    // boolean property restores native constraint validation after parsing.
    form.noValidate = false;

    const syncPasswords = () => {
      confirmation.setCustomValidity(password.value === confirmation.value ? '' : 'Passwords do not match');
    };

    const text = (name) => {
      const el = form.elements.namedItem(name);
      return el && typeof el.value === 'string' ? el.value.trim() : '';
    };
    const checked = (name) => {
      const el = form.elements.namedItem(name);
      return Boolean(el && el.checked);
    };

    const showStatus = (message, linkUrl) => {
      if (!status) return;
      status.textContent = message;
      if (linkUrl) {
        const link = document.createElement('a');
        link.href = linkUrl;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = 'Log in';
        status.append(document.createTextNode(' '), link);
      }
      status.hidden = false;
    };

    const showSent = () => {
      form.setAttribute('data-cp-state', 'sent');
      if (title && form.dataset.successTitle) title.textContent = form.dataset.successTitle;
      if (success) success.hidden = false;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (card) card.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (title) title.focus({ preventScroll: true });
    };

    const errorMessage = (response, data) => {
      const code = data && data.code;
      const fields = data && Array.isArray(data.fields) ? data.fields : [];
      if ((response && response.status === 409) || code === 'exists') return { message: form.dataset.msgExists, link: form.dataset.loginUrl };
      if (code === 'fields' && fields.includes('email')) return { message: form.dataset.msgEmail };
      if (code === 'fields' && fields.includes('password')) return { message: form.dataset.msgPassword };
      if (response && response.status === 429) return { message: form.dataset.msgRate };
      return { message: form.dataset.msgError };
    };

    const submitApplication = async () => {
      sending = true;
      if (status) {
        status.hidden = true;
        status.textContent = '';
      }
      const originalLabel = ctaLabel ? ctaLabel.textContent : '';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }
      if (ctaLabel && form.dataset.sending) ctaLabel.textContent = form.dataset.sending;

      // password_confirmation stays in the browser. The password is sent as typed (no trim) so it matches what the creator logs in with.
      const body = JSON.stringify({
        first_name: text('first_name'),
        last_name: text('last_name'),
        email: text('email'),
        password: password.value,
        twitch: text('twitch'),
        tiktok: text('tiktok'),
        youtube: text('youtube'),
        instagram: text('instagram'),
        content_link: text('content_link'),
        sponsor_alerts: checked('sponsor_alerts'),
        age_confirm: checked('age_confirm'),
        website_url: (form.elements.namedItem('website_url') || {}).value || '',
        started_at: startedAt,
      });

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
      let response = null;
      let data = null;
      try {
        if (!form.dataset.endpoint) throw new Error('No submit endpoint');
        response = await fetch(form.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          signal: controller.signal,
        });
        data = await response.json().catch(() => null);
      } catch (error) {
        data = null;
      } finally {
        clearTimeout(timer);
      }

      if (response && response.ok && data && data.ok === true) {
        showSent();
        return;
      }

      const failure = errorMessage(response, data);
      showStatus(failure.message || form.dataset.msgError || '', failure.link);
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
      if (ctaLabel) ctaLabel.textContent = originalLabel;
      sending = false;
    };

    const onSubmit = (event) => {
      syncPasswords();
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      event.preventDefault();
      if (sending) return;
      submitApplication();
    };
    // Terms and Privacy pop-ups (native modal dialogs). Page scroll locks on overflow-y only,
    // so the html, body overflow-x: clip guard is never touched.
    const pops = Array.from(root.querySelectorAll('[data-cp-pop]'));
    const popCloseButtons = Array.from(root.querySelectorAll('[data-cp-pop-close]'));
    const unlockPageScroll = () => {
      document.documentElement.style.overflowY = '';
    };
    const openPop = (event) => {
      event.preventDefault();
      const dialog = root.querySelector('[data-cp-pop="' + event.currentTarget.dataset.cpLightbox + '"]');
      if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
      dialog.showModal();
      document.documentElement.style.overflowY = 'hidden';
      const popBody = dialog.querySelector('.ero-cp-application__pop-body');
      if (popBody) popBody.scrollTop = 0;
    };
    const onPopCloseClick = (event) => {
      const dialog = event.currentTarget.closest('[data-cp-pop]');
      if (dialog && dialog.open) dialog.close();
    };
    // The panel fills the dialog, so the dialog itself is the target only on the backdrop.
    const onPopPointerDown = (event) => {
      if (event.target === event.currentTarget && event.currentTarget.open) event.currentTarget.close();
    };
    const onPopClose = () => {
      unlockPageScroll();
      // iOS paints a focus ring on the link focus returns to (same as the testimonials lightbox).
      requestAnimationFrame(() => {
        if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      });
    };

    confirmation.addEventListener('input', syncPasswords);
    form.addEventListener('submit', onSubmit);
    lightboxLinks.forEach((link) => link.addEventListener('click', openPop));
    popCloseButtons.forEach((button) => button.addEventListener('click', onPopCloseClick));
    pops.forEach((dialog) => {
      dialog.addEventListener('pointerdown', onPopPointerDown);
      dialog.addEventListener('close', onPopClose);
    });

    root._eroCpApplicationCleanup = () => {
      confirmation.removeEventListener('input', syncPasswords);
      form.removeEventListener('submit', onSubmit);
      lightboxLinks.forEach((link) => link.removeEventListener('click', openPop));
      popCloseButtons.forEach((button) => button.removeEventListener('click', onPopCloseClick));
      const popWasOpen = pops.some((dialog) => dialog.open);
      pops.forEach((dialog) => {
        dialog.removeEventListener('pointerdown', onPopPointerDown);
        dialog.removeEventListener('close', onPopClose);
        if (dialog.open) dialog.close();
      });
      // The close event fires after its listener is gone, so unlock here.
      if (popWasOpen) unlockPageScroll();
      delete root._eroCpApplicationCleanup;
    };
  }

  function eventRoot(event) {
    const target = event.target;
    if (!target || !target.querySelector) return null;
    const root = target.matches(selector) ? target : target.querySelector(selector);
    if (!root) return null;
    if (event.detail && event.detail.sectionId && root.dataset.sectionId !== String(event.detail.sectionId)) return null;
    return root;
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = eventRoot(event);
    if (root) init(root);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const root = eventRoot(event);
    if (root && root._eroCpApplicationCleanup) root._eroCpApplicationCleanup();
  });

  function initAll() {
    document.querySelectorAll(selector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-cp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Shopify compiles this block once for all instances of this section type.
  const selector = '[data-section-type="ero-cp-hero"]';

  function init(root) {
    if (root._eroCpHeroCleanup) return;
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || tabs.length !== panels.length) return;
    const unbind = [];

    const select = (index, moveFocus = false) => {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        panels[i].hidden = !active;
      });
      if (moveFocus) tabs[index].focus();
    };

    tabs.forEach((tab, index) => {
      const onPointerUp = (event) => {
        if (event.button !== 0 || event.isPrimary === false) return;
        select(index);
      };
      const onKeyDown = (event) => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        select(next, true);
      };
      tab.addEventListener('pointerup', onPointerUp);
      tab.addEventListener('keydown', onKeyDown);
      unbind.push(() => {
        tab.removeEventListener('pointerup', onPointerUp);
        tab.removeEventListener('keydown', onKeyDown);
      });
    });

    root._eroCpHeroCleanup = () => {
      unbind.forEach((remove) => remove());
      delete root._eroCpHeroCleanup;
    };
    select(0);
  }

  function eventRoot(event) {
    const target = event.target;
    if (!target || !target.querySelector) return null;
    const root = target.matches(selector) ? target : target.querySelector(selector);
    if (!root) return null;
    if (event.detail && event.detail.sectionId && root.dataset.sectionId !== String(event.detail.sectionId)) return null;
    return root;
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = eventRoot(event);
    if (root) init(root);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const root = eventRoot(event);
    if (root && root._eroCpHeroCleanup) root._eroCpHeroCleanup();
  });

  function initAll() {
    document.querySelectorAll(selector).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // APPLY NOW (and any link whose href is exactly #ero-cp-application)
  // scrolls smoothly to the form instead of jumping. The landing spot is the
  // form section's scroll-margin-top (the fixed nav's height). One delegated
  // listener, so theme editor reloads need no rebinding. A cta_url that is not
  // this same-page hash does not match and navigates normally.
  const applyHash = '#ero-cp-application';
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest && event.target.closest('a[href="' + applyHash + '"]');
    if (!link) return;
    const target = document.getElementById(applyHash.slice(1));
    if (!target) return;
    event.preventDefault();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (window.location.hash !== applyHash) history.pushState(null, '', applyHash);

    // Focus the form heading once the scroll ends: scrollend where supported
    // or a 700ms timer, whichever comes first, run once.
    const heading = document.getElementById('ero-cp-application-title-' + target.dataset.sectionId);
    if (!heading) return;
    if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
    let done = false;
    let timer = 0;
    const finish = () => {
      if (done) return;
      done = true;
      window.removeEventListener('scrollend', finish);
      clearTimeout(timer);
      heading.focus({ preventScroll: true });
    };
    if ('onscrollend' in window) window.addEventListener('scrollend', finish);
    timer = setTimeout(finish, 700);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-creator-proof-bar"]) return;
  try {
    
  (function () {
    const init = () => {
      const marquee = document.querySelector('.ero-cpb__marquee');
      if (!marquee) return;
      const tracks = Array.from(marquee.querySelectorAll('.ero-cpb__track'));
      if (!tracks.length) return;

      const TRACK_UNIT = 640;
      const DURATION_MS = 20000;
      const SWIPE_PX = 8;
      const AXIS_LOCK_PX = 6;
      const VEL_WINDOW_MS = 100;
      const FRICTION_PER_16MS = 0.95;
      const MIN_VEL_PX_PER_MS = 0.04;

      const reducedMotion = () =>
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const readTransformX = (el) => {
        const t = getComputedStyle(el).transform;
        if (!t || t === 'none') return 0;
        const m = t.match(/matrix[^(]*\(([^)]+)\)/);
        if (!m) return 0;
        const v = m[1].split(',').map(Number);
        return v.length === 6 ? v[4] : v[12];
      };

      // Wrap x into [-TRACK_UNIT, 0]. The 5 identical track copies make the
      // layout periodic at TRACK_UNIT px, so wrapping is visually seamless
      // and prevents the content from scrolling off-screen on long drags.
      const wrap = (x) => {
        let n = x % TRACK_UNIT;
        if (n > 0) n -= TRACK_UNIT;
        return n;
      };

      const applyInlineTransform = (x) => {
        const w = wrap(x);
        for (const t of tracks) t.style.transform = 'translateX(' + w + 'px)';
      };

      const pauseCss = (x) => {
        const w = wrap(x);
        for (const t of tracks) {
          t.style.animation = 'none';
          t.style.transform = 'translateX(' + w + 'px)';
        }
      };

      const resumeCss = (x) => {
        const w = wrap(x);
        if (reducedMotion()) {
          for (const t of tracks) {
            t.style.animation = 'none';
            t.style.transform = 'translateX(' + w + 'px)';
          }
          return;
        }
        const elapsed = (-w / TRACK_UNIT) * DURATION_MS;
        for (const t of tracks) {
          t.style.transform = '';
          t.style.animation = 'ero-cpb-scroll ' + DURATION_MS + 'ms linear infinite';
          t.style.animationDelay = '-' + elapsed + 'ms';
        }
      };

      const state = {
        dragging: false,
        pointerKind: null,
        startX: 0,
        startY: 0,
        lastClientX: 0,
        offsetAtStart: 0,
        axis: null,
        moved: 0,
        swiped: false,
        samples: [],
        rafId: null
      };

      const stopMomentum = () => {
        if (state.rafId !== null) {
          cancelAnimationFrame(state.rafId);
          state.rafId = null;
        }
      };

      const pointerStart = (clientX, clientY, kind) => {
        stopMomentum();
        const currentX = readTransformX(tracks[0]);
        state.dragging = true;
        state.pointerKind = kind;
        state.startX = clientX;
        state.startY = clientY;
        state.lastClientX = clientX;
        state.offsetAtStart = currentX;
        // Touch locks axis to avoid hijacking vertical page scroll; mouse
        // drag on a non-scrolling element commits to horizontal immediately.
        state.axis = kind === 'mouse' ? 'x' : null;
        state.moved = 0;
        state.swiped = false;
        state.samples = [{ t: performance.now(), x: clientX }];
        pauseCss(currentX);
        if (kind === 'mouse') marquee.classList.add('is-grabbing');
      };

      const pointerMove = (clientX, clientY, e) => {
        if (!state.dragging) return;
        const dx = clientX - state.startX;
        const dy = clientY - state.startY;

        if (state.axis === null) {
          if (Math.abs(dx) > AXIS_LOCK_PX || Math.abs(dy) > AXIS_LOCK_PX) {
            state.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          }
        }

        if (state.axis !== 'x') return;

        if (e && e.cancelable) e.preventDefault();
        state.lastClientX = clientX;
        state.moved = Math.max(state.moved, Math.abs(dx));
        if (state.moved > SWIPE_PX) state.swiped = true;
        applyInlineTransform(state.offsetAtStart + dx);

        const now = performance.now();
        state.samples.push({ t: now, x: clientX });
        while (state.samples.length > 2 && now - state.samples[0].t > VEL_WINDOW_MS) {
          state.samples.shift();
        }
      };

      const pointerEnd = () => {
        if (!state.dragging) return;
        state.dragging = false;
        marquee.classList.remove('is-grabbing');

        const finalX = state.offsetAtStart + (state.lastClientX - state.startX);

        if (state.axis !== 'x') {
          resumeCss(state.offsetAtStart);
          return;
        }

        let vel = 0;
        if (state.samples.length >= 2) {
          const first = state.samples[0];
          const last = state.samples[state.samples.length - 1];
          const dt = last.t - first.t;
          if (dt > 0) vel = (last.x - first.x) / dt;
        }

        if (Math.abs(vel) < MIN_VEL_PX_PER_MS) {
          resumeCss(finalX);
          return;
        }

        let x = finalX;
        let lastT = performance.now();
        const step = (now) => {
          const dt = now - lastT;
          lastT = now;
          x += vel * dt;
          vel *= Math.pow(FRICTION_PER_16MS, dt / 16);
          applyInlineTransform(x);
          if (Math.abs(vel) < MIN_VEL_PX_PER_MS) {
            resumeCss(x);
            state.rafId = null;
            return;
          }
          state.rafId = requestAnimationFrame(step);
        };
        state.rafId = requestAnimationFrame(step);
      };

      // Touch
      const onTouchStart = (e) => {
        if (e.touches.length !== 1) return;
        pointerStart(e.touches[0].clientX, e.touches[0].clientY, 'touch');
      };
      const onTouchMove = (e) => {
        if (state.pointerKind !== 'touch' || e.touches.length !== 1) return;
        pointerMove(e.touches[0].clientX, e.touches[0].clientY, e);
      };
      const onTouchEnd = () => {
        if (state.pointerKind !== 'touch') return;
        pointerEnd();
      };
      marquee.addEventListener('touchstart', onTouchStart, { passive: true });
      marquee.addEventListener('touchmove', onTouchMove, { passive: false });
      marquee.addEventListener('touchend', onTouchEnd, { passive: true });
      marquee.addEventListener('touchcancel', onTouchEnd, { passive: true });

      // Mouse — window-level move/up so drag survives cursor leaving marquee
      const onMouseMove = (e) => {
        if (state.pointerKind !== 'mouse') return;
        pointerMove(e.clientX, e.clientY, e);
      };
      const onMouseUp = () => {
        if (state.pointerKind !== 'mouse') return;
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        pointerEnd();
      };
      marquee.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        // Blocks focus + text-selection side effects of mousedown.
        e.preventDefault();
        pointerStart(e.clientX, e.clientY, 'mouse');
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
      });

      // Click suppression — unified for touch + mouse drags.
      marquee.addEventListener('click', (e) => {
        if (state.swiped) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-detail-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const isActivationKey = (event) => event.key === 'Enter' || event.key === ' ';

    function initRoot(root) {
      if (root._eroDetailTabsCleanup) return;

      const tabs = Array.from(root.querySelectorAll('[data-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-panel]'));
      if (!tabs.length || !panels.length) return;

      const controller = new AbortController();
      const signal = controller.signal;

      // Class swap only. Nothing animates and nothing is added or removed
      // from the DOM, so the panel that is not showing keeps its content
      // and its ids for the aria wiring.
      function selectTab(key) {
        tabs.forEach(function (tab) {
          const selected = tab.dataset.tab === key;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.panel === key);
        });
      }

      tabs.forEach(function (tab) {
        const activate = function () {
          selectTab(tab.dataset.tab);
        };
        tab.addEventListener('pointerup', activate, { signal: signal });
        tab.addEventListener('keydown', function (event) {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          activate();
        }, { signal: signal });
      });

      root._eroDetailTabsCleanup = function () {
        controller.abort();
        delete root._eroDetailTabsCleanup;
      };
    }

    function initAll(scope) {
      const context = scope || document;
      if (context.matches && context.matches('[data-ero-detail-tabs]')) initRoot(context);
      context.querySelectorAll('[data-ero-detail-tabs]').forEach(initRoot);
    }

    if (document.readyState === 'complete') {
      initAll(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      }, { once: true });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      const root = event.target.matches && event.target.matches('[data-ero-detail-tabs]')
        ? event.target
        : event.target.querySelector('[data-ero-detail-tabs]');
      if (root && root._eroDetailTabsCleanup) root._eroDetailTabsCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-ingredient-transparency"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const DEFAULT_INDEX = 3;

    const hexToRgba = (hex, alpha) => {
      let h = String(hex || '').trim().replace('#', '');
      if (h.length === 3) {
        h = h.split('').map(function (c) { return c + c; }).join('');
      }
      const r = parseInt(h.slice(0, 2), 16);
      const g = parseInt(h.slice(2, 4), 16);
      const b = parseInt(h.slice(4, 6), 16);
      if (isNaN(r) || isNaN(g) || isNaN(b)) return 'rgba(0, 184, 212, ' + alpha + ')';
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    const getSlideAccent = (slide) => {
      if (!slide) return '#00B8D4';
      const style = slide.getAttribute('style') || '';
      const match = style.match(/--card-accent:\s*([^;]+)/);
      return match ? match[1].trim() : '#00B8D4';
    };

    const CARD_STEP = 200;
    const PEEK_OFFSET_BASE = 60;

    const getU = () => {
      const u = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--u'));
      return isNaN(u) || u <= 0 ? 1 : u;
    };

    // Holographic shimmer + tilt is owned by assets/ero-shimmer.css and
    // assets/ero-shimmer.js (both loaded globally from theme.liquid).
    // The shimmer system reads the existing `.active` class on slides,
    // attaches its own pointer listeners to .ero-it__card, and drives
    // --shimmer-x/--shimmer-y/--tilt-x/--tilt-y. Gyro (Phase C) is not
    // yet shipped; mobile gets the static Phase A treatment.
    // Aurora is pure CSS — keyframes above. No JS init needed.

    const init = (section) => {
      if (section.dataset.ittInit === '1') return;
      section.dataset.ittInit = '1';

      const viewport = section.querySelector('[data-viewport]');
      const track = section.querySelector('[data-track]');
      const slides = Array.from(section.querySelectorAll('[data-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-dot]'));
      const prevBtn = section.querySelector('[data-arrow-prev]');
      const nextBtn = section.querySelector('[data-arrow-next]');

      if (!track || slides.length === 0) return;
      if (typeof gsap === 'undefined') return;

      gsap.registerPlugin(Draggable, InertiaPlugin);

      const mm = gsap.matchMedia();

      // Aurora animation throttle: idle state runs only the active card's
      // 3 blobs; during swipe, also run both neighbors (with wrap) so they're
      // already drifting when sliding into view. Reduces 21 continuously
      // animated compositor layers to 3 in idle, max 9 during a swipe.
      // Pure animation-play-state toggle — never removes/re-adds the
      // animation property, so blob positions are preserved across pause/run.
      const setSlideAuroraRunning = (slide, isRunning) => {
        if (!slide) return;
        const blobs = slide.querySelectorAll('.ero-it__aurora-blob');
        const state = isRunning ? 'running' : 'paused';
        for (let i = 0; i < blobs.length; i++) {
          blobs[i].style.animationPlayState = state;
        }
      };

      mm.add('(max-width: 989px) and (prefers-reduced-motion: no-preference)', () => {
        const count = slides.length;
        let currentIndex = DEFAULT_INDEX < count ? DEFAULT_INDEX : 0;

        const snaps = slides.map(function (_, i) { return -i * CARD_STEP; });

        const proxy = document.createElement('div');
        proxy.setAttribute('aria-hidden', 'true');
        proxy.style.cssText = 'position:fixed;top:-9999px;left:0;width:1px;height:1px;opacity:0;pointer-events:none;';
        section.appendChild(proxy);

        // Cards stay fully opaque while visible — the dim is rendered by
        // .ero-it__card::before as a semi-transparent black overlay tied to
        // the .ero-it__slide.active class. Opacity is only used to fully
        // hide cards beyond ±1.5 (where they leave the deck entirely).
        const positionCards = (activeIndex, interpolatedOffset) => {
          const peekPx = PEEK_OFFSET_BASE * getU();
          for (let i = 0; i < slides.length; i++) {
            const dist = i - activeIndex + interpolatedOffset;
            const absDist = Math.abs(dist);
            const slide = slides[i];

            if (absDist > 1.5) {
              slide.style.opacity = '0';
              slide.style.pointerEvents = 'none';
              slide.style.zIndex = '0';
              slide.style.transform = 'translate(-50%, -50%) scale(0.9)';
              continue;
            }

            let scale;
            if (absDist <= 1) {
              scale = 1 - absDist * 0.10;
            } else {
              const t = (absDist - 1) / 0.5;
              scale = 0.9 - t * 0.05;
            }

            const xOffset = dist * peekPx;
            const zIndex = Math.max(0, Math.round(10 - absDist * 5));

            slide.style.transform =
              'translateX(calc(-50% + ' + xOffset + 'px)) translateY(-50%) scale(' + scale.toFixed(4) + ')';
            slide.style.opacity = '1';
            slide.style.zIndex = String(zIndex);
            slide.style.pointerEvents = absDist < 1.2 ? 'auto' : 'none';
          }
        };

        const update = (prevIdx) => {
          slides.forEach((slide, i) => {
            if (i === currentIndex) {
              slide.classList.add('active');
              slide.setAttribute('aria-current', 'true');
            } else {
              slide.classList.remove('active');
              slide.removeAttribute('aria-current');
            }
          });

          dots.forEach((dot, i) => {
            const accent = dot.dataset.accent || '#00B8D4';
            if (i === currentIndex) {
              dot.classList.add('active');
              dot.setAttribute('aria-current', 'true');
              dot.style.setProperty('--dot-base', accent);
              dot.style.backgroundColor = accent;
            } else {
              dot.classList.remove('active');
              dot.removeAttribute('aria-current');
              dot.style.backgroundColor = 'color-mix(in srgb, ' + accent + ' 20%, transparent)';
            }
          });

          if (prevBtn) {
            if (currentIndex <= 0) prevBtn.classList.add('disabled');
            else prevBtn.classList.remove('disabled');
          }
          if (nextBtn) {
            if (currentIndex >= count - 1) nextBtn.classList.add('disabled');
            else nextBtn.classList.remove('disabled');
          }

          const accent = getSlideAccent(slides[currentIndex]);
          section.style.setProperty('--active-accent', accent);
          section.style.setProperty('--active-accent-20', hexToRgba(accent, 0.20));
        };

        const setIdleAurora = () => {
          for (let i = 0; i < slides.length; i++) {
            setSlideAuroraRunning(slides[i], i === currentIndex);
          }
        };
        const setSwipeAurora = () => {
          const prev = (currentIndex - 1 + count) % count;
          const next = (currentIndex + 1) % count;
          for (let i = 0; i < slides.length; i++) {
            const running = i === currentIndex || i === prev || i === next;
            setSlideAuroraRunning(slides[i], running);
          }
        };

        // Disable transitions for first paint so peek cards don't fly in from center.
        track.classList.add('is-dragging');
        gsap.set(proxy, { x: snaps[currentIndex] });
        positionCards(currentIndex, 0);
        track.offsetHeight; /* eslint-disable-line no-unused-expressions */
        requestAnimationFrame(function () {
          track.classList.remove('is-dragging');
        });

        const findNearestSnapIndex = (x) => {
          let idx = 0;
          let bestDist = Infinity;
          for (let i = 0; i < snaps.length; i++) {
            const d = Math.abs(x - snaps[i]);
            if (d < bestDist) { bestDist = d; idx = i; }
          }
          return idx;
        };

        const updateFromProxy = () => {
          const x = gsap.getProperty(proxy, 'x');
          const nearestIdx = findNearestSnapIndex(x);
          if (nearestIdx !== currentIndex) {
            const prev = currentIndex;
            currentIndex = nearestIdx;
            update(prev);
          }
          const offset = (x - snaps[currentIndex]) / CARD_STEP;
          positionCards(currentIndex, offset);
        };

        let dragStartIndex = currentIndex;
        let drag = null;

        // Drag/swipe is touch-only. On desktop the cards are click-only —
        // tapping a peek card (handled below via pointerup) moves one step.
        // Skipping Draggable entirely avoids GSAP's micro-drag detection
        // hijacking simple mouse clicks with momentum/inertia.
        const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

        if (isTouchDevice) {
          drag = Draggable.create(proxy, {
            type: 'x',
            trigger: track,
            inertia: true,
            edgeResistance: 0.85,
            dragResistance: 0.05,
            minimumMovement: 6,
            dragClickables: true,
            allowNativeTouchScrolling: true,
            bounds: { minX: snaps[snaps.length - 1], maxX: snaps[0] },
            snap: {
              x: function (endValue) {
                var bestIdx = dragStartIndex;
                var bestDist = Math.abs(endValue - snaps[dragStartIndex]);
                var minIdx = Math.max(0, dragStartIndex - 2);
                var maxIdx = Math.min(snaps.length - 1, dragStartIndex + 2);
                for (var i = minIdx; i <= maxIdx; i++) {
                  var d = Math.abs(endValue - snaps[i]);
                  if (d < bestDist) { bestDist = d; bestIdx = i; }
                }
                return snaps[bestIdx];
              }
            },
            onPress: function () {
              setSwipeAurora();
            },
            onDragStart: function () {
              dragStartIndex = currentIndex;
              track.classList.add('is-dragging');
            },
            onDrag: updateFromProxy,
            onThrowUpdate: updateFromProxy,
            onThrowComplete: function () {
              updateFromProxy();
              positionCards(currentIndex, 0);
              track.classList.remove('is-dragging');
              setIdleAurora();
            }
          })[0];

          section._dragInstance = drag;
        }

        const goTo = (idx) => {
          if (idx < 0) idx = 0;
          if (idx > count - 1) idx = count - 1;
          if (idx === currentIndex) return;
          const prev = currentIndex;
          currentIndex = idx;
          update(prev);
          setIdleAurora();
          track.classList.add('is-dragging');
          gsap.to(proxy, {
            x: snaps[idx],
            duration: 0.35,
            ease: 'power2.out',
            onUpdate: function () {
              const x = gsap.getProperty(proxy, 'x');
              const offset = (x - snaps[idx]) / CARD_STEP;
              positionCards(idx, offset);
            },
            onComplete: function () {
              positionCards(currentIndex, 0);
              track.classList.remove('is-dragging');
            }
          });
        };

        const goPrev = () => goTo(currentIndex - 1);
        const goNext = () => goTo(currentIndex + 1);

        const stopProp = (e) => e.stopPropagation();
        const onPrevClick = (e) => { e.preventDefault(); goPrev(); };
        const onNextClick = (e) => { e.preventDefault(); goNext(); };
        if (prevBtn) {
          prevBtn.addEventListener('pointerdown', stopProp);
          prevBtn.addEventListener('click', onPrevClick);
        }
        if (nextBtn) {
          nextBtn.addEventListener('pointerdown', stopProp);
          nextBtn.addEventListener('click', onNextClick);
        }

        const dotHandlers = dots.map((dot) => {
          const onDown = (e) => e.stopPropagation();
          const onClick = (e) => {
            e.preventDefault();
            const idx = parseInt(dot.dataset.index, 10) || 0;
            goTo(idx);
          };
          dot.addEventListener('pointerdown', onDown);
          dot.addEventListener('click', onClick);
          return { dot, onDown, onClick };
        });

        // Tap-to-activate on peek cards (±1). Use pointerup with a movement
        // threshold so a swipe doesn't fire as a tap. Click events can be eaten
        // by Draggable, so pointerup is the safer hook.
        const slideHandlers = slides.map((slide) => {
          let downX = 0;
          let downY = 0;
          let downTime = 0;

          const onDown = (e) => {
            downX = e.clientX;
            downY = e.clientY;
            downTime = Date.now();
          };

          const onUp = (e) => {
            const dx = Math.abs(e.clientX - downX);
            const dy = Math.abs(e.clientY - downY);
            const dt = Date.now() - downTime;
            if (dx > 10 || dy > 10 || dt > 600) return;

            const idx = parseInt(slide.dataset.index, 10);
            if (isNaN(idx)) return;
            if (idx === currentIndex) return;
            if (Math.abs(idx - currentIndex) > 1) return;

            e.preventDefault();
            e.stopPropagation();
            goTo(idx);
          };

          slide.addEventListener('pointerdown', onDown);
          slide.addEventListener('pointerup', onUp);
          return { slide, onDown, onUp };
        });

        let resizeTimeout;
        const onResize = () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(function () {
            gsap.set(proxy, { x: snaps[currentIndex] });
            positionCards(currentIndex, 0);
          }, 150);
        };
        window.addEventListener('resize', onResize, { passive: true });

        update(-1);
        setIdleAurora();

        // matchMedia cleanup — runs when viewport crosses to desktop or
        // user enables reduced motion. Detach every listener and remove
        // the proxy element so the next mobile cycle starts clean.
        return () => {
          if (drag) { drag.kill(); section._dragInstance = null; }
          clearTimeout(resizeTimeout);
          window.removeEventListener('resize', onResize);
          if (prevBtn) {
            prevBtn.removeEventListener('pointerdown', stopProp);
            prevBtn.removeEventListener('click', onPrevClick);
          }
          if (nextBtn) {
            nextBtn.removeEventListener('pointerdown', stopProp);
            nextBtn.removeEventListener('click', onNextClick);
          }
          dotHandlers.forEach(({ dot, onDown, onClick }) => {
            dot.removeEventListener('pointerdown', onDown);
            dot.removeEventListener('click', onClick);
          });
          slideHandlers.forEach(({ slide, onDown, onUp }) => {
            slide.removeEventListener('pointerdown', onDown);
            slide.removeEventListener('pointerup', onUp);
          });
          slides.forEach((slide) => {
            slide.style.transform = '';
            slide.style.opacity = '';
            slide.style.zIndex = '';
            slide.style.pointerEvents = '';
            slide.classList.remove('active');
            slide.removeAttribute('aria-current');
            // Resume aurora on every slide so static state at desktop
            // doesn't leave most blobs frozen mid-drift.
            const blobs = slide.querySelectorAll('.ero-it__aurora-blob');
            for (let i = 0; i < blobs.length; i++) blobs[i].style.animationPlayState = '';
          });
          if (proxy.parentNode) proxy.parentNode.removeChild(proxy);
          track.classList.remove('is-dragging');
        };
      });

      mm.add('(min-width: 990px) and (prefers-reduced-motion: no-preference)', () => {
        const count = slides.length;
        let currentIndex = DEFAULT_INDEX < count ? DEFAULT_INDEX : 0;

        // Desktop carousel: all 7 cards visible, overlapping fan layout.
        // Center card is full scale, cards fan out left/right with decreasing
        // scale and increasing overlap. Infinite loop — index wraps around.

        const DESKTOP_CARD_STEP = 160; // px offset per card position at u-desktop=1
        const DESKTOP_PEEK_SCALE = 0.88; // scale for adjacent cards
        const DESKTOP_FAR_SCALE = 0.78; // scale for cards 2+ positions away

        const getUDesktop = () => {
          const vw = window.innerWidth;
          return Math.min(vw, 1920) / 1440;
        };

        const wrapIndex = (i) => ((i % count) + count) % count;

        const positionCards = (centerIdx, fractionalOffset) => {
          const u = getUDesktop();
          const step = DESKTOP_CARD_STEP * u;

          for (let i = 0; i < count; i++) {
            const slide = slides[i];

            let dist = i - centerIdx + fractionalOffset;
            if (dist > count / 2) dist -= count;
            if (dist < -count / 2) dist += count;

            const absDist = Math.abs(dist);

            let scale;
            if (absDist < 0.01) {
              scale = 1;
            } else if (absDist <= 1) {
              scale = 1 - absDist * (1 - DESKTOP_PEEK_SCALE);
            } else if (absDist <= 2) {
              scale = DESKTOP_PEEK_SCALE - (absDist - 1) * (DESKTOP_PEEK_SCALE - DESKTOP_FAR_SCALE);
            } else {
              scale = DESKTOP_FAR_SCALE - (absDist - 2) * 0.08;
              if (scale < 0.62) scale = 0.62;
            }

            const xOffset = dist * step;
            const zIndex = Math.round(10 - absDist * 2);

            slide.style.transform =
              'translateX(calc(-50% + ' + xOffset + 'px)) translateY(-50%) scale(' + scale.toFixed(4) + ')';
            slide.style.opacity = '1';
            slide.style.zIndex = String(Math.max(0, zIndex));
            slide.style.pointerEvents = absDist < 0.5 ? 'auto' : 'none';

            if (absDist < 0.5 && fractionalOffset === 0) {
              slide.classList.add('active');
              slide.setAttribute('aria-current', 'true');
            } else if (fractionalOffset === 0) {
              slide.classList.remove('active');
              slide.removeAttribute('aria-current');
            }
          }
        };

        const updateDim = () => {
          slides.forEach((slide, i) => {
            if (i === currentIndex) {
              slide.classList.add('active');
            } else {
              slide.classList.remove('active');
            }
          });
        };

        const updateNavState = () => {
          const accent = getSlideAccent(slides[currentIndex]);
          section.style.setProperty('--active-accent', accent);
          section.style.setProperty('--active-accent-20', hexToRgba(accent, 0.20));
          updateDim();
          for (let i = 0; i < slides.length; i++) {
            const dist = Math.abs(i - currentIndex);
            const wrappedDist = Math.min(dist, count - dist);
            setSlideAuroraRunning(slides[i], wrappedDist <= 1);
          }
        };

        const desktopPrev = section.querySelector('[data-desktop-arrow-prev]');
        const desktopNext = section.querySelector('[data-desktop-arrow-next]');

        const goTo = (newIdx) => {
          const targetIdx = wrapIndex(newIdx);
          if (targetIdx === currentIndex) return;

          let diff = targetIdx - currentIndex;
          if (diff > count / 2) diff -= count;
          if (diff < -count / 2) diff += count;

          const direction = diff;

          slides.forEach((slide, i) => {
            if (i === targetIdx) {
              slide.classList.add('active');
              slide.setAttribute('aria-current', 'true');
            } else {
              slide.classList.remove('active');
              slide.removeAttribute('aria-current');
            }
          });
          const newAccent = getSlideAccent(slides[targetIdx]);
          section.style.setProperty('--active-accent', newAccent);
          section.style.setProperty('--active-accent-20', hexToRgba(newAccent, 0.20));

          track.classList.add('is-dragging');
          gsap.to({ progress: 0 }, {
            progress: 1,
            duration: 0.4,
            ease: 'power2.out',
            onUpdate: function () {
              const p = this.targets()[0].progress;
              const fractional = direction * (1 - p);
              positionCards(targetIdx, fractional);
            },
            onComplete: function () {
              currentIndex = targetIdx;
              positionCards(currentIndex, 0);
              updateNavState();
              track.classList.remove('is-dragging');
            }
          });
        };

        const goPrev = () => goTo(currentIndex - 1);
        const goNext = () => goTo(currentIndex + 1);

        const onDesktopPrevClick = (e) => { e.preventDefault(); goPrev(); };
        const onDesktopNextClick = (e) => { e.preventDefault(); goNext(); };
        if (desktopPrev) desktopPrev.addEventListener('click', onDesktopPrevClick);
        if (desktopNext) desktopNext.addEventListener('click', onDesktopNextClick);

        const proxy = document.createElement('div');
        proxy.setAttribute('aria-hidden', 'true');
        proxy.style.cssText = 'position:fixed;top:-9999px;left:0;width:1px;height:1px;opacity:0;pointer-events:none;';
        section.appendChild(proxy);

        let dragStartIdx = currentIndex;

        gsap.set(proxy, { x: 0 });

        const drag = Draggable.create(proxy, {
          type: 'x',
          trigger: track,
          inertia: true,
          edgeResistance: 0.65,
          dragResistance: 0.05,
          minimumMovement: 8,
          dragClickables: true,
          snap: {
            x: function (endValue) {
              const step = DESKTOP_CARD_STEP * getUDesktop();
              return Math.round(endValue / step) * step;
            }
          },
          onDragStart: function () {
            dragStartIdx = currentIndex;
            track.classList.add('is-dragging');
          },
          onDrag: function () {
            const x = gsap.getProperty(proxy, 'x');
            const step = DESKTOP_CARD_STEP * getUDesktop();
            const offset = x / step;
            positionCards(wrapIndex(dragStartIdx - Math.round(offset)), (offset % 1));
          },
          onThrowUpdate: function () {
            const x = gsap.getProperty(proxy, 'x');
            const step = DESKTOP_CARD_STEP * getUDesktop();
            const offset = x / step;
            positionCards(wrapIndex(dragStartIdx - Math.round(offset)), (offset % 1));
          },
          onThrowComplete: function () {
            const x = gsap.getProperty(proxy, 'x');
            const step = DESKTOP_CARD_STEP * getUDesktop();
            const cardsMoved = Math.round(x / step);
            currentIndex = wrapIndex(dragStartIdx - cardsMoved);
            slides.forEach((slide, i) => {
              if (i === currentIndex) {
                slide.classList.add('active');
                slide.setAttribute('aria-current', 'true');
              } else {
                slide.classList.remove('active');
                slide.removeAttribute('aria-current');
              }
            });
            const dragAccent = getSlideAccent(slides[currentIndex]);
            section.style.setProperty('--active-accent', dragAccent);
            section.style.setProperty('--active-accent-20', hexToRgba(dragAccent, 0.20));
            gsap.set(proxy, { x: 0 });
            positionCards(currentIndex, 0);
            updateNavState();
            track.classList.remove('is-dragging');
          }
        })[0];

        const slideClickHandlers = slides.map((slide) => {
          const onClick = (e) => {
            const idx = parseInt(slide.dataset.index, 10);
            if (isNaN(idx) || idx === currentIndex) return;
            e.preventDefault();
            goTo(idx);
          };
          slide.addEventListener('click', onClick);
          return { slide, onClick };
        });

        const onKeyDown = (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); goPrev(); }
          if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); }
        };
        section.setAttribute('tabindex', '0');
        section.addEventListener('keydown', onKeyDown);

        track.classList.add('is-dragging');
        positionCards(currentIndex, 0);
        updateNavState();
        const initialAccent = getSlideAccent(slides[currentIndex]);
        section.style.setProperty('--active-accent', initialAccent);
        section.style.setProperty('--active-accent-20', hexToRgba(initialAccent, 0.20));
        track.offsetHeight;
        requestAnimationFrame(() => { track.classList.remove('is-dragging'); });

        let resizeTimeout;
        const onResize = () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            positionCards(currentIndex, 0);
          }, 150);
        };
        window.addEventListener('resize', onResize, { passive: true });

        return () => {
          if (drag) drag.kill();
          if (desktopPrev) desktopPrev.removeEventListener('click', onDesktopPrevClick);
          if (desktopNext) desktopNext.removeEventListener('click', onDesktopNextClick);
          slideClickHandlers.forEach(({ slide, onClick }) => {
            slide.removeEventListener('click', onClick);
          });
          section.removeEventListener('keydown', onKeyDown);
          section.removeAttribute('tabindex');
          clearTimeout(resizeTimeout);
          window.removeEventListener('resize', onResize);
          slides.forEach((slide) => {
            slide.style.transform = '';
            slide.style.opacity = '';
            slide.style.zIndex = '';
            slide.style.pointerEvents = '';
            slide.classList.remove('active');
            slide.removeAttribute('aria-current');
            const blobs = slide.querySelectorAll('.ero-it__aurora-blob');
            for (let b = 0; b < blobs.length; b++) blobs[b].style.animationPlayState = '';
          });
          if (proxy.parentNode) proxy.parentNode.removeChild(proxy);
          track.classList.remove('is-dragging');
        };
      });

      // Expose the matchMedia revert so the section:unload handler can
      // tear the subscription down on theme-editor section reload.
      section._ittMmRevert = () => { mm.revert(); };
    };

    const initAll = () => {
      document.querySelectorAll('.ero-it').forEach(init);
    };

    if (document.readyState === 'complete') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      const section = e.target.classList && e.target.classList.contains('ero-it')
        ? e.target
        : e.target.querySelector && e.target.querySelector('.ero-it');
      if (section) init(section);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target) return;
      const sec = e.target.classList && e.target.classList.contains('ero-it')
        ? e.target
        : e.target.querySelector && e.target.querySelector('.ero-it');
      if (!sec) return;
      // Revert the matchMedia subscription first — its cleanup function
      // kills Draggable, removes listeners, and strips the proxy element.
      if (typeof sec._ittMmRevert === 'function') {
        sec._ittMmRevert();
        delete sec._ittMmRevert;
      }
      if (sec._dragInstance) {
        sec._dragInstance.kill();
        delete sec._dragInstance;
      }
      delete sec.dataset.ittInit;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-pdp-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const isActivationKey = (event) => event.key === 'Enter' || event.key === ' ';

    function updateHeaderCartCount(itemCount) {
      const count = String(itemCount || 0);

      document.querySelectorAll('.ero-nav__cart-badge').forEach((badge) => {
        badge.dataset.count = count;
        badge.textContent = count;
        const link = badge.closest('a');
        if (link) link.setAttribute('aria-label', 'Cart, ' + count + ' items');
      });

      let bubbles = Array.from(document.querySelectorAll('.cart-count-bubble'));
      const cartLink = document.getElementById('cart-icon-bubble');
      if (bubbles.length === 0 && cartLink && itemCount > 0) {
        const bubble = document.createElement('div');
        const visibleCount = document.createElement('span');
        const accessibleCount = document.createElement('span');
        bubble.className = 'cart-count-bubble';
        visibleCount.setAttribute('aria-hidden', 'true');
        accessibleCount.className = 'visually-hidden';
        bubble.append(visibleCount, accessibleCount);
        cartLink.appendChild(bubble);
        bubbles = [bubble];
      }

      bubbles.forEach((bubble) => {
        /* Write the number only, never build markup. ERO's
           .ero-nav__cart-badge now carries .cart-count-bubble so this loop
           matches it, and that badge holds a bare text node: prepending a
           span inside it rendered the count twice. The .ero-nav__cart-badge
           loop above has already set its textContent. */
        const visibleCount = bubble.querySelector('[aria-hidden="true"]');
        if (visibleCount) visibleCount.textContent = count;

        const accessibleCount = bubble.querySelector('.visually-hidden');
        if (accessibleCount) {
          const currentLabel = accessibleCount.textContent;
          accessibleCount.textContent = /\d+/.test(currentLabel)
            ? currentLabel.replace(/\d+/, count)
            : count + ' items';
        }
      });
    }

    function refreshCartCount(signal) {
      return fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        signal: signal
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart count refresh failed.');
          return response.json();
        })
        .then((cartData) => {
          updateHeaderCartCount(cartData.item_count);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'pdp-cross-sell',
              cartData: cartData
            });
          }
        });
    }

    function addVariant(variantId, signal) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: { _source: 'pdp_crosssell' }
            }
          ]
        }),
        signal: signal
      }).then((response) => response.json().then((data) => ({ response: response, data: data })))
        .then((result) => {
          if (!result.response.ok || result.data.status) {
            throw new Error(result.data.description || result.data.message || 'Unable to add this item.');
          }
          return result.data;
        });
    }

    function initRoot(root) {
      if (root.dataset.pdpXsellInit === '1') return;
      root.dataset.pdpXsellInit = '1';

      const controller = new AbortController();
      const signal = controller.signal;
      const timers = [];
      const swatches = Array.from(root.querySelectorAll('.ero-pdp-xsell__swatch'));
      const shakerCta = root.querySelector('[data-xsell-cta="shaker"]');
      const price = root.querySelector('[data-shaker-price]');
      const photo = root.querySelector('[data-shaker-photo]');

      function selectSwatch(button) {
        swatches.forEach((swatch) => {
          const selected = swatch === button;
          swatch.classList.toggle('is-selected', selected);
          swatch.setAttribute('aria-checked', selected ? 'true' : 'false');
          swatch.setAttribute('tabindex', selected ? '0' : '-1');
        });

        root.dataset.color = button.dataset.color;
        if (shakerCta) shakerCta.dataset.variantId = button.dataset.variantId;
        if (price) price.textContent = button.dataset.priceLabel;

        if (photo) {
          let image = photo.querySelector('[data-shaker-image]');
          const nextSource = button.dataset.imageSrc;
          const nextAspectRatio = button.dataset.imageAspectRatio;
          if (nextSource && !image) {
            image = document.createElement('img');
            image.className = 'ero-pdp-xsell__photo-image';
            image.dataset.shakerImage = '';
            image.loading = 'lazy';
            image.sizes = '(min-width: 990px) 294px, (max-width: 480px) 33vw, 156px';
            photo.appendChild(image);
          }
          if (image) {
            image.hidden = !nextSource;
            if (nextSource) {
              image.src = nextSource;
              image.srcset = button.dataset.imageSrcset || '';
              image.alt = button.dataset.imageAlt || '';
              image.width = button.dataset.imageWidth || '143';
              image.height = button.dataset.imageHeight || '210';
              if (nextAspectRatio) {
                image.style.aspectRatio = nextAspectRatio;
              } else {
                image.style.removeProperty('aspect-ratio');
              }
            }
          }
        }
      }

      swatches.forEach((button) => {
        button.addEventListener('pointerup', () => selectSwatch(button), { signal: signal });
        button.addEventListener('keydown', (event) => {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          selectSwatch(button);
        }, { signal: signal });
      });

      root.querySelectorAll('[data-xsell-cta]').forEach((button) => {
        const label = button.querySelector('[data-xsell-label]');
        const errorNode = button.parentElement.querySelector('[data-xsell-error]');
        const originalLabel = label ? label.textContent : '';
        let busy = false;

        function showError(message) {
          if (!errorNode) return;
          errorNode.textContent = message;
          errorNode.hidden = false;
        }

        function clearError() {
          if (!errorNode) return;
          errorNode.textContent = '';
          errorNode.hidden = true;
        }

        function restoreButton() {
          if (label) label.textContent = originalLabel;
          button.classList.remove('is-added');
          button.removeAttribute('aria-disabled');
          busy = false;
        }

        function fire() {
          const variantId = button.dataset.variantId;
          if (busy || !variantId) return;

          busy = true;
          button.setAttribute('aria-disabled', 'true');
          clearError();

          addVariant(variantId, signal)
            .then(() => {
              button.classList.add('is-added');
              if (label) label.textContent = 'Added \u2713';
              refreshCartCount(signal).catch((error) => {
                if (error.name !== 'AbortError') console.error(error);
              });
              timers.push(window.setTimeout(restoreButton, 2200));
            })
            .catch((error) => {
              restoreButton();
              if (error.name === 'AbortError') return;
              const fallback = window.cartStrings && window.cartStrings.error
                ? window.cartStrings.error
                : 'Unable to add this item. Please try again.';
              const message = error.message || fallback;
              showError(message);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'pdp-cross-sell',
                  productVariantId: variantId,
                  errors: message,
                  message: message
                });
              }
              console.error('ERO PDP cross-sell add failed.', error);
            });
        }

        button.addEventListener('pointerup', fire, { signal: signal });
        button.addEventListener('keydown', (event) => {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          fire();
        }, { signal: signal });
      });

      root._eroPdpXsellCleanup = function () {
        controller.abort();
        timers.forEach((timer) => window.clearTimeout(timer));
        delete root.dataset.pdpXsellInit;
        delete root._eroPdpXsellCleanup;
      };
    }

    function initAll(scope) {
      const context = scope || document;
      if (context.matches && context.matches('[data-ero-pdp-xsell]')) initRoot(context);
      context.querySelectorAll('[data-ero-pdp-xsell]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches && event.target.matches('[data-ero-pdp-xsell]')
        ? event.target
        : event.target.querySelector('[data-ero-pdp-xsell]');
      if (root && root._eroPdpXsellCleanup) root._eroPdpXsellCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const init = (section) => {
      if (section.dataset.pdpRevInit === '1') return;
      section.dataset.pdpRevInit = '1';

      const viewport = section.querySelector('[data-viewport]');
      const track = section.querySelector('[data-track]');
      const slides = Array.from(section.querySelectorAll('[data-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-dot]'));
      const prevBtn = section.querySelector('[data-arrow-prev]');
      const nextBtn = section.querySelector('[data-arrow-next]');
      const expandBtns = Array.from(section.querySelectorAll('[data-expand]'));

      if (!track || slides.length === 0) return;
      if (typeof gsap === 'undefined') return;

      const sectionId = section.dataset.sectionId;
      const lightbox = document.querySelector('[data-lightbox="' + sectionId + '"]');
      const mediaSlot = lightbox ? lightbox.querySelector('[data-lightbox-media]') : null;
      const nameSlot = lightbox ? lightbox.querySelector('[data-lightbox-name]') : null;
      const variantSlot = lightbox ? lightbox.querySelector('[data-lightbox-variant]') : null;
      const closeBtn = lightbox ? lightbox.querySelector('[data-lightbox-close]') : null;

      // ──────────────────────────────────────────────────────
      // Lightbox — non-animation UI, lives outside matchMedia.
      // ──────────────────────────────────────────────────────
      const openLightbox = (data) => {
        if (!lightbox || !mediaSlot) return;
        mediaSlot.innerHTML = '';
        if (data.video && data.embed) {
          // Loox video: a Cloudflare Stream player page, so an iframe. Only
          // an https url from the Loox data is used.
          let url = null;
          try {
            url = new URL(data.video, window.location.href);
          } catch (err) {
            url = null;
          }
          if (!url || url.protocol !== 'https:') return;
          url.searchParams.set('autoplay', 'true');
          const frame = document.createElement('iframe');
          frame.src = url.href;
          frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
          frame.setAttribute('allowfullscreen', '');
          frame.title = 'Video review from ' + data.name;
          mediaSlot.appendChild(frame);
        } else if (data.video) {
          const video = document.createElement('video');
          video.src = data.video;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          mediaSlot.appendChild(video);
        } else if (data.photo) {
          const img = document.createElement('img');
          img.src = data.photo;
          img.alt = 'Photo from ' + data.name;
          img.style.maxWidth = '100%';
          img.style.maxHeight = '100%';
          img.style.borderRadius = '10px';
          mediaSlot.appendChild(img);
        }
        if (nameSlot) nameSlot.textContent = data.name || '';
        if (variantSlot) variantSlot.textContent = data.variant || '';
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
      };

      // iOS Safari returns focus to the expand button after <dialog> closes,
      // which renders a focus indicator painted on the ancestor card. Blur
      // after rAF so the dialog close has settled before focus is stripped.
      const blurAfterClose = () => {
        requestAnimationFrame(() => {
          if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
          }
        });
      };

      const closeLightbox = () => {
        if (!lightbox) return;
        const video = mediaSlot ? mediaSlot.querySelector('video') : null;
        if (video) {
          try { video.pause(); } catch (err) { /* noop */ }
        }
        if (mediaSlot) mediaSlot.innerHTML = '';
        if (typeof lightbox.close === 'function') lightbox.close();
        blurAfterClose();
      };

      expandBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openLightbox({
            photo: btn.dataset.photo || '',
            video: btn.dataset.video || '',
            embed: btn.dataset.embed === '1',
            name: btn.dataset.name || '',
            variant: btn.dataset.variant || ''
          });
        });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          closeLightbox();
        });
      }
      if (lightbox) {
        lightbox.addEventListener('click', (e) => {
          if (e.target === lightbox) closeLightbox();
        });
        lightbox.addEventListener('close', () => {
          if (mediaSlot) mediaSlot.innerHTML = '';
          blurAfterClose();
        });
      }

      // ──────────────────────────────────────────────────────
      // Carousel — GSAP Draggable + per-frame scale on mobile;
      // simple arrow-click navigation on desktop. Both buckets
      // live in the same matchMedia instance below.
      // ──────────────────────────────────────────────────────
      const mm = gsap.matchMedia();

      mm.add('(max-width: 989px) and (prefers-reduced-motion: no-preference)', () => {
        // Measure at runtime so carousel geometry respects --u scaling AND
        // the slide's negative margin-right overlap in one shot: step =
        // width + marginRight resolves to 327 + (-48) = 279 at the baseline.
        const firstSlideEl = slides[0];
        const SLIDE_WIDTH = firstSlideEl ? firstSlideEl.offsetWidth : 327;
        const slideMarginRight = firstSlideEl
          ? parseFloat(getComputedStyle(firstSlideEl).marginRight)
          : -48;
        const EFFECTIVE_STEP = SLIDE_WIDTH + slideMarginRight;

        const lastZIndex = new Array(slides.length).fill(null);
        const count = slides.length;
        let currentIndex = 0;

        const SCALE_MIN = 0.9;
        const SCALE_MAX = 1.0;
        const SCALE_RANGE = SCALE_MAX - SCALE_MIN;

        const applyScales = (trackTranslateX, cachedSlideWidth, cachedViewportCenter) => {
          if (!slides.length) return;
          if (typeof trackTranslateX !== 'number') trackTranslateX = gsap.getProperty(track, 'x');
          const slideWidth = cachedSlideWidth !== undefined ? cachedSlideWidth : (slides[0].offsetWidth || SLIDE_WIDTH);
          const slideStep = EFFECTIVE_STEP;
          const firstSlideCenter = track.offsetLeft + slides[0].offsetLeft + slideWidth / 2;
          const viewportCenter = cachedViewportCenter !== undefined
            ? cachedViewportCenter
            : ((viewport && viewport.offsetWidth ? viewport.offsetWidth : window.innerWidth) / 2);
          for (let i = 0; i < slides.length; i++) {
            const slideCenterInTrack = firstSlideCenter + (i * slideStep);
            const slideCenterInViewport = trackTranslateX + slideCenterInTrack;
            const offsetFromCenter = Math.abs(slideCenterInViewport - viewportCenter);
            const normalized = Math.min(1, offsetFromCenter / slideStep);
            const scale = SCALE_MAX - (normalized * SCALE_RANGE);
            slides[i].style.transform = 'scale(' + scale.toFixed(4) + ')';
            slides[i].style.setProperty('--peek-opacity', normalized.toFixed(4));
            const newZ = Math.round(scale * 100);
            if (lastZIndex[i] !== newZ) {
              slides[i].style.zIndex = newZ;
              lastZIndex[i] = newZ;
            }
          }
        };

        const update = (prevIdx) => {
          slides.forEach((slide, i) => {
            if (i === currentIndex) {
              slide.classList.add('active');
              slide.setAttribute('aria-current', 'true');
            } else {
              slide.classList.remove('active');
              slide.removeAttribute('aria-current');
            }
          });

          dots.forEach((dot, i) => {
            if (i === currentIndex) {
              dot.classList.add('active');
              dot.setAttribute('aria-selected', 'true');
            } else {
              dot.classList.remove('active');
              dot.setAttribute('aria-selected', 'false');
            }
          });

          if (prevBtn) {
            if (currentIndex <= 0) prevBtn.setAttribute('disabled', '');
            else prevBtn.removeAttribute('disabled');
          }
          if (nextBtn) {
            if (currentIndex >= count - 1) nextBtn.setAttribute('disabled', '');
            else nextBtn.removeAttribute('disabled');
          }
        };

        const findNearestSnapIndex = (x) => {
          let idx = 0;
          let bestDist = Infinity;
          for (let i = 0; i < snaps.length; i++) {
            const d = Math.abs(x - snaps[i]);
            if (d < bestDist) { bestDist = d; idx = i; }
          }
          return { idx, dist: bestDist };
        };

        let throwSettled = false;
        let dragStartIndex = 0;

        gsap.registerPlugin(Draggable, InertiaPlugin);

        function buildSnaps() {
          const vw = viewport.offsetWidth;
          const trackOffset = track.offsetLeft;
          return slides.map((s) => (vw / 2) - (trackOffset + s.offsetLeft + s.offsetWidth / 2));
        }
        let snaps = buildSnaps();

        gsap.set(track, { x: snaps[0] });
        applyScales();

        const drag = Draggable.create(track, {
          type: 'x',
          inertia: true,
          edgeResistance: 0.85,
          dragResistance: 0.05,
          minimumMovement: 6,
          dragClickables: true,
          bounds: { minX: snaps[snaps.length - 1], maxX: snaps[0] },
          snap: {
            x: function (endValue) {
              var bestIdx = dragStartIndex;
              var bestDist = Math.abs(endValue - snaps[dragStartIndex]);
              var minIdx = Math.max(0, dragStartIndex - 2);
              var maxIdx = Math.min(snaps.length - 1, dragStartIndex + 2);
              for (var i = minIdx; i <= maxIdx; i++) {
                var d = Math.abs(endValue - snaps[i]);
                if (d < bestDist) { bestDist = d; bestIdx = i; }
              }
              return snaps[bestIdx];
            }
          },
          onDragStart: function () {
            throwSettled = false;
            dragStartIndex = currentIndex;
          },
          onDrag: applyScales,
          onThrowUpdate: function () {
            applyScales();
            if (throwSettled) return;
            const x = gsap.getProperty(track, 'x');
            const { idx } = findNearestSnapIndex(x);
            if (idx !== currentIndex) {
              throwSettled = true;
              const prev = currentIndex;
              currentIndex = idx;
              update(prev);
            }
          },
          onThrowComplete: function () {
            const finalX = gsap.getProperty(track, 'x');
            const { idx } = findNearestSnapIndex(finalX);
            if (idx !== currentIndex) {
              const prev = currentIndex;
              currentIndex = idx;
              update(prev);
            } else {
              applyScales();
            }
            throwSettled = true;
          }
        })[0];

        section._dragInstance = drag;

        const goTo = (idx) => {
          if (idx < 0) idx = 0;
          if (idx > count - 1) idx = count - 1;
          const prev = currentIndex;
          currentIndex = idx;
          update(prev);
          gsap.to(track, {
            x: snaps[idx],
            duration: 0.35,
            ease: 'quint.out',
            onUpdate: applyScales
          });
        };

        const goPrev = () => goTo(currentIndex - 1);
        const goNext = () => goTo(currentIndex + 1);

        const onPrevDown = (e) => { e.stopPropagation(); };
        const onNextDown = (e) => { e.stopPropagation(); };
        const onPrevClick = (e) => { e.preventDefault(); goPrev(); };
        const onNextClick = (e) => { e.preventDefault(); goNext(); };
        if (prevBtn) prevBtn.addEventListener('pointerdown', onPrevDown);
        if (nextBtn) nextBtn.addEventListener('pointerdown', onNextDown);
        if (prevBtn) prevBtn.addEventListener('click', onPrevClick);
        if (nextBtn) nextBtn.addEventListener('click', onNextClick);

        const dotHandlers = dots.map((dot) => {
          const onDown = (e) => { e.stopPropagation(); };
          const onClick = (e) => {
            e.preventDefault();
            const idx = parseInt(dot.dataset.index, 10) || 0;
            goTo(idx);
          };
          dot.addEventListener('pointerdown', onDown);
          dot.addEventListener('click', onClick);
          return { dot, onDown, onClick };
        });

        const slideHandlers = slides.map((slide) => {
          const onClick = (e) => {
            const idx = parseInt(slide.dataset.index, 10);
            if (isNaN(idx)) return;
            if (idx !== currentIndex) {
              e.preventDefault();
              goTo(idx);
            }
          };
          slide.addEventListener('click', onClick);
          return { slide, onClick };
        });

        let resizeTimeout;
        const onResize = () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            snaps = buildSnaps();
            drag.applyBounds({ minX: snaps[snaps.length - 1], maxX: snaps[0] });
            drag.vars.snap = {
              x: function (endValue) {
                var bestIdx = dragStartIndex;
                var bestDist = Math.abs(endValue - snaps[dragStartIndex]);
                var minIdx = Math.max(0, dragStartIndex - 2);
                var maxIdx = Math.min(snaps.length - 1, dragStartIndex + 2);
                for (var i = minIdx; i <= maxIdx; i++) {
                  var d = Math.abs(endValue - snaps[i]);
                  if (d < bestDist) { bestDist = d; bestIdx = i; }
                }
                return snaps[bestIdx];
              }
            };
            gsap.set(track, { x: snaps[currentIndex] });
            applyScales();
          }, 150);
        };
        window.addEventListener('resize', onResize, { passive: true });

        const onKeydown = (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); goPrev(); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); }
        };
        if (viewport) viewport.addEventListener('keydown', onKeydown);

        update(-1);

        // matchMedia cleanup runs on viewport cross to desktop.
        // Detach every listener we bound inside this bucket and reset
        // the slide inline styles + track transform so the desktop
        // bucket (empty for now) starts from a clean static layout.
        return () => {
          if (drag) { drag.kill(); section._dragInstance = null; }
          clearTimeout(resizeTimeout);
          window.removeEventListener('resize', onResize);
          if (viewport) viewport.removeEventListener('keydown', onKeydown);
          if (prevBtn) {
            prevBtn.removeEventListener('pointerdown', onPrevDown);
            prevBtn.removeEventListener('click', onPrevClick);
          }
          if (nextBtn) {
            nextBtn.removeEventListener('pointerdown', onNextDown);
            nextBtn.removeEventListener('click', onNextClick);
          }
          dotHandlers.forEach(({ dot, onDown, onClick }) => {
            dot.removeEventListener('pointerdown', onDown);
            dot.removeEventListener('click', onClick);
          });
          slideHandlers.forEach(({ slide, onClick }) => {
            slide.removeEventListener('click', onClick);
          });
          slides.forEach((slide) => {
            slide.style.transform = '';
            slide.style.removeProperty('--peek-opacity');
            slide.style.zIndex = '';
            slide.classList.remove('active');
            slide.removeAttribute('aria-current');
          });
          gsap.set(track, { x: 0 });
        };
      });

      mm.add('(min-width: 990px)', () => {
        // Desktop: simple arrow-click navigation. No Draggable, no scale
        // effects. Track shifts by one card width + gap per click.
        // All 5 cards in DOM, 3 visible at once, overflow hidden on track.

        const count = slides.length;
        let currentIndex = 0;
        const VISIBLE_COUNT = 3;
        const maxIndex = Math.max(0, count - VISIBLE_COUNT);

        // Measure card width + gap at runtime for accurate step
        function getStep() {
          if (slides.length < 2) return slides[0] ? slides[0].offsetWidth : 388;
          return slides[1].offsetLeft - slides[0].offsetLeft;
        }

        function updateArrows() {
          if (prevBtn) prevBtn.removeAttribute('disabled');
          if (nextBtn) nextBtn.removeAttribute('disabled');
        }

        function goTo(idx) {
          if (idx > maxIndex) idx = 0;
          if (idx < 0) idx = maxIndex;
          currentIndex = idx;
          updateArrows();
          gsap.to(track, {
            x: -(getStep() * currentIndex),
            duration: 0.4,
            ease: 'power2.out'
          });
        }

        const onPrevClick = (e) => { e.preventDefault(); goTo(currentIndex - 1); };
        const onNextClick = (e) => { e.preventDefault(); goTo(currentIndex + 1); };
        const onPrevDown = (e) => { e.stopPropagation(); };
        const onNextDown = (e) => { e.stopPropagation(); };

        if (prevBtn) {
          prevBtn.addEventListener('pointerdown', onPrevDown);
          prevBtn.addEventListener('click', onPrevClick);
        }
        if (nextBtn) {
          nextBtn.addEventListener('pointerdown', onNextDown);
          nextBtn.addEventListener('click', onNextClick);
        }

        // Keyboard nav on viewport
        const onKeydown = (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex - 1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex + 1); }
        };
        if (viewport) viewport.addEventListener('keydown', onKeydown);

        // Initialize
        gsap.set(track, { x: 0 });
        updateArrows();

        // Card body click → open lightbox with full review (desktop only).
        // Only on cards where review text overflows (line-clamp truncated).
        var cardClickHandlers = [];
        slides.forEach(function(slide) {
          var card = slide.querySelector('.ero-pdp-review-card');
          var cardBody = card ? card.querySelector('.ero-pdp-review-card__body') : null;
          var review = card ? card.querySelector('.ero-pdp-review-card__review') : null;
          if (!cardBody || !review) return;

          var isOverflowing = review.scrollHeight > review.clientHeight;
          if (!isOverflowing) return;

          cardBody.style.cursor = 'pointer';

          var onClick = function(e) {
            if (e.target.closest('.ero-pdp-review-card__expand')) return;
            e.preventDefault();
            e.stopPropagation();

            var reviewerName = card.querySelector('.ero-pdp-review-card__reviewer-name');
            var reviewerVariant = card.querySelector('.ero-pdp-review-card__variant');

            if (mediaSlot) {
              var fullReview = document.createElement('div');
              fullReview.style.cssText = 'max-width:600px;padding:40px;background:rgba(155,109,255,0.15);border:2px solid #9B6DFF;border-radius:12px;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);font-family:Space Grotesk,sans-serif;font-size:16px;line-height:1.6;color:#fff;';
              fullReview.textContent = review.textContent;
              mediaSlot.innerHTML = '';
              mediaSlot.appendChild(fullReview);
            }
            if (nameSlot) nameSlot.textContent = reviewerName ? reviewerName.textContent : '';
            if (variantSlot) variantSlot.textContent = reviewerVariant ? reviewerVariant.textContent : '';
            if (typeof lightbox.showModal === 'function') lightbox.showModal();
          };

          cardBody.addEventListener('click', onClick);
          cardClickHandlers.push({ cardBody: cardBody, onClick: onClick });
        });

        // Cleanup on breakpoint cross back to mobile
        return () => {
          if (prevBtn) {
            prevBtn.removeEventListener('pointerdown', onPrevDown);
            prevBtn.removeEventListener('click', onPrevClick);
          }
          if (nextBtn) {
            nextBtn.removeEventListener('pointerdown', onNextDown);
            nextBtn.removeEventListener('click', onNextClick);
          }
          if (viewport) viewport.removeEventListener('keydown', onKeydown);
          cardClickHandlers.forEach(function(h) {
            h.cardBody.removeEventListener('click', h.onClick);
            h.cardBody.style.cursor = '';
          });
          gsap.set(track, { x: 0 });
        };
      });

      // Hook so the existing shopify:section:unload listener can revert
      // the matchMedia subscription cleanly when the editor swaps the
      // section out.
      section._pdpReviewsMmRevert = () => { mm.revert(); };
    };

    // ──────────────────────────────────────────────────────
    // Live Loox reviews (8.2). The same source as this page's buy box:
    // the bag follows the selected flavor (Bundle combines both), the
    // Sample Pack uses its own reviews, the Shaker and Hat use Blue
    // Raspberry + Peach Mango combined. The buy box publishes the resolved
    // ids as root._eroReviewSourceIds(). 10 reviews, rated 4 or 5, newest
    // first, one card per reviewer. The manual blocks are the fallback:
    // Loox off, Loox down, no buy box, or nothing qualifying.
    // Excluded reviewers are already dropped by assets/ero-loox.js.
    // ──────────────────────────────────────────────────────
    const REV_CAP_MS = 2500;
    const REV_MAX_CARDS = 10;
    const REV_MIN_RATING = 4;
    const REV_PRODUCT_LABELS = {
      '8663383998714': 'Blue Raspberry',
      '8663387898106': 'Peach Mango',
      '8674785886458': 'Sample Pack'
    };

    const looxApi = () => (window.EroLoox && typeof window.EroLoox.productReviews === 'function'
      ? window.EroLoox
      : null);
    const buyBoxRoot = () => document.querySelector('[data-ero-pdp-buy-box]');
    const idsKey = (ids) => ids.map(String).join(',');
    const reviewTime = (review) => Date.parse(review.date || review.createdAt) || 0;

    // Merged across the ids, rated 4+, with a body, newest first, one card
    // per reviewer, first 10. null when every call fails; an empty array
    // when nothing qualifies.
    const fetchRevCards = (ids) => {
      const api = looxApi();
      if (!api || !ids.length) return Promise.resolve(null);
      return Promise.all(ids.map((id) => api.productReviews(id, { limit: 100, sort: 'date' })))
        .then((lists) => {
          const ok = lists.filter(Array.isArray);
          if (!ok.length) return null;
          const merged = [].concat(...ok)
            .filter((review) => review && Number(review.rating) >= REV_MIN_RATING)
            .sort((a, b) => reviewTime(b) - reviewTime(a));
          const used = new Set();
          const cards = [];
          for (let i = 0; i < merged.length && cards.length < REV_MAX_CARDS; i += 1) {
            const review = merged[i];
            const body = String(review.body || '').trim();
            const name = String((review.reviewer && review.reviewer.name) || '').trim();
            if (!body || !name || used.has(name)) continue;
            used.add(name);
            cards.push({ review: review, body: body, name: name });
          }
          return cards;
        })
        .catch(() => null);
    };

    const revInitials = (name) => String(name || '').trim().split(/\s+/).filter(Boolean)
      .slice(0, 2).map((word) => word.charAt(0)).join('').toUpperCase();

    const revVariant = (review) => {
      const product = review.product || {};
      return REV_PRODUCT_LABELS[String(product.id)] || product.name || '';
    };

    // First photo wins; otherwise the first video with a thumbnail. A video
    // review never shows initials (Taylor's ruling).
    const revMedia = (review) => {
      const media = Array.isArray(review.media) ? review.media : [];
      const photo = media.find((item) => item && item.type === 'photo' && item.url);
      if (photo) return { type: 'photo', src: photo.url };
      const video = media.find((item) => item && item.type === 'video' && item.url && item.thumbnailUrl);
      if (video) return { type: 'video', src: video.thumbnailUrl, video: video.url };
      return null;
    };

    // The homepage UGC play triangle (.ero-ugc__play-icon).
    const SVG_NS = 'http://www.w3.org/2000/svg';
    const buildPlayIcon = () => {
      const svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('viewBox', '0 0 14 16');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const polygon = document.createElementNS(SVG_NS, 'polygon');
      polygon.setAttribute('points', '0,0 14,8 0,16');
      polygon.setAttribute('fill', 'white');
      svg.appendChild(polygon);
      return svg;
    };

    // textContent and attributes only; review text never goes through
    // innerHTML.
    const buildRevSlide = (template, card, index) => {
      const slide = template.content.firstElementChild.cloneNode(true);
      slide.dataset.index = String(index);
      slide.classList.toggle('active', index === 0);

      const review = card.review;
      const variant = revVariant(review);
      const media = revMedia(review);
      const img = slide.querySelector('.ero-pdp-review-card__photo');
      const initials = slide.querySelector('.ero-pdp-review-card__initials');
      const expand = slide.querySelector('[data-expand]');

      if (media && media.type === 'video') {
        // Thumbnail in the photo slot; the expand button becomes the play
        // badge and opens the Loox player in the lightbox iframe.
        if (img) {
          img.src = media.src;
          img.alt = 'Video from ' + card.name;
        }
        if (initials) initials.remove();
        if (expand) {
          expand.classList.add('ero-pdp-review-card__expand--play');
          expand.dataset.photo = '';
          expand.dataset.video = media.video;
          expand.dataset.embed = '1';
          expand.dataset.name = card.name;
          expand.dataset.variant = variant;
          expand.setAttribute('aria-label', 'Play video from ' + card.name);
          const icon = expand.querySelector('.ero-pdp-review-card__expand-icon');
          if (icon) icon.replaceChildren(buildPlayIcon());
        }
      } else if (media) {
        if (img) {
          img.src = media.src;
          img.alt = 'Photo from ' + card.name;
        }
        if (initials) initials.remove();
        if (expand) {
          expand.dataset.photo = media.src;
          expand.dataset.video = '';
          expand.dataset.name = card.name;
          expand.dataset.variant = variant;
          expand.setAttribute('aria-label', 'Expand media from ' + card.name);
        }
      } else {
        if (img) img.remove();
        if (expand) expand.remove();
        if (initials) {
          initials.textContent = revInitials(card.name);
          initials.setAttribute('aria-label', card.name + ' avatar');
        }
      }

      // Ratings can be 4 here, so the row is built: rating filled stars,
      // then 5 - rating empty ones, cloned from the two prototypes.
      const stars = slide.querySelector('.ero-pdp-review-card__stars');
      if (stars) {
        const rating = Math.max(0, Math.min(5, Math.round(Number(review.rating) || 0)));
        const filled = stars.querySelector('[data-star-proto="filled"]');
        const empty = stars.querySelector('[data-star-proto="empty"]');
        const row = [];
        for (let i = 0; i < 5; i += 1) {
          const proto = i < rating ? filled : empty;
          if (!proto) continue;
          const star = proto.cloneNode(true);
          star.removeAttribute('data-star-proto');
          row.push(star);
        }
        stars.replaceChildren(...row);
        stars.setAttribute('aria-label', 'Rating: ' + rating + ' out of 5');
      }

      const text = slide.querySelector('.ero-pdp-review-card__review');
      if (text) text.textContent = card.body;
      const nameNode = slide.querySelector('.ero-pdp-review-card__reviewer-name');
      if (nameNode) nameNode.textContent = card.name;
      const variantNode = slide.querySelector('.ero-pdp-review-card__variant');
      if (variantNode) variantNode.textContent = variant;
      const badge = slide.querySelector('.ero-pdp-review-card__verified-badge');
      if (badge && review.verified !== true) badge.remove();
      return slide;
    };

    // Same markup and attributes the Liquid dots loop prints.
    const buildRevDot = (index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ero-pdp-reviews__dot' + (index === 0 ? ' active' : '');
      dot.setAttribute('data-dot', '');
      dot.dataset.index = String(index);
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      dot.setAttribute('aria-label', 'Go to testimonial ' + (index + 1));
      return dot;
    };

    // The Liquid blocks are kept the first time live cards replace them, so
    // a later flavor with nothing qualifying can put them back.
    const keepRevFallback = (section, track, dotsWrap) => {
      if (section._revFallback) return;
      section._revFallback = {
        slides: Array.from(track.children),
        dots: dotsWrap ? Array.from(dotsWrap.children) : []
      };
    };

    const renderRevCards = (section, cards) => {
      const template = section.querySelector('template[data-loox-card-template]');
      const track = section.querySelector('[data-track]');
      const dotsWrap = section.querySelector('[data-dots]');
      if (!template || !track || !cards.length) return;
      keepRevFallback(section, track, dotsWrap);
      track.replaceChildren(...cards.map((card, index) => buildRevSlide(template, card, index)));
      if (dotsWrap) dotsWrap.replaceChildren(...cards.map((card, index) => buildRevDot(index)));
      section._revShowingLive = true;
    };

    const restoreRevBlocks = (section) => {
      const fallback = section._revFallback;
      const track = section.querySelector('[data-track]');
      const dotsWrap = section.querySelector('[data-dots]');
      if (!fallback || !track) return;
      track.replaceChildren(...fallback.slides);
      if (dotsWrap) dotsWrap.replaceChildren(...fallback.dots);
      fallback.slides.forEach((slide, index) => slide.classList.toggle('active', index === 0));
      fallback.dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === 0);
        dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      });
      section._revShowingLive = false;
    };

    // The one replace path for a running carousel: revert it, swap the
    // cards and dots, initialise again. Used for a late Loox answer and for
    // every flavor change on the bag PDP.
    const reinitRev = (section, swap) => {
      if (typeof section._pdpReviewsMmRevert === 'function') {
        section._pdpReviewsMmRevert();
        delete section._pdpReviewsMmRevert;
      }
      if (section._dragInstance) {
        section._dragInstance.kill();
        delete section._dragInstance;
      }
      delete section.dataset.pdpRevInit;
      swap();
      init(section);
    };

    // Before the carousel first starts, the answer (or the 2.5s cap) is
    // what starts it, with the track and dots hidden meanwhile. Once it is
    // running, an answer swaps through reinitRev. A newer request (a flavor
    // change) makes any older answer stale via the token.
    const loadRev = (section, ids) => {
      section._revKey = idsKey(ids);
      const token = (section._revToken || 0) + 1;
      section._revToken = token;
      window.clearTimeout(section._revTimer);

      if (section.dataset.pdpRevInit !== '1') {
        section.classList.add('is-loox-pending');
        section._revTimer = window.setTimeout(() => {
          if (section._revToken !== token || section.dataset.pdpRevInit === '1') return;
          section.classList.remove('is-loox-pending');
          init(section);
        }, REV_CAP_MS);
      }

      fetchRevCards(ids).then((cards) => {
        if (section._revToken !== token) return;
        const hasCards = Array.isArray(cards) && cards.length > 0;

        if (section.dataset.pdpRevInit !== '1') {
          window.clearTimeout(section._revTimer);
          if (hasCards) renderRevCards(section, cards);
          section.classList.remove('is-loox-pending');
          init(section);
          return;
        }

        if (hasCards) {
          reinitRev(section, () => renderRevCards(section, cards));
        } else if (section._revShowingLive) {
          reinitRev(section, () => restoreRevBlocks(section));
        }
      });
    };

    // Bag PDP flavor changes. Quantity and plan changes dispatch the same
    // event, so it only acts when the resolved ids actually differ.
    const bindRevSource = (section) => {
      if (section._revOnChange) return;
      section._revOnChange = () => {
        const box = buyBoxRoot();
        if (!box || typeof box._eroReviewSourceIds !== 'function') return;
        const ids = box._eroReviewSourceIds();
        if (idsKey(ids) === section._revKey) return;
        loadRev(section, ids);
      };
      document.addEventListener('ero:buybox:change', section._revOnChange);
    };

    // The buy box initialises on the same DOMContentLoaded, AFTER this
    // section (its script loads later in the page), so on first load its
    // review source is not published yet. One retry on the next task runs
    // after every DOMContentLoaded listener has finished.
    const boot = (section, retried) => {
      if (section.dataset.loox === 'false' || !looxApi()) {
        init(section);
        return;
      }
      const box = buyBoxRoot();
      if (!box) {
        init(section);
        return;
      }
      if (typeof box._eroReviewSourceIds !== 'function') {
        if (!retried) {
          section.classList.add('is-loox-pending');
          window.setTimeout(() => boot(section, true), 0);
          return;
        }
        section.classList.remove('is-loox-pending');
        init(section);
        return;
      }
      bindRevSource(section);
      loadRev(section, box._eroReviewSourceIds());
    };

    const initAll = () => {
      document.querySelectorAll('.ero-pdp-reviews').forEach((section) => boot(section));
    };

    // DCL is guaranteed to fire AFTER all deferred scripts execute, so gsap/
    // Draggable/InertiaPlugin are defined by the time initAll runs. Shopify's
    // compiled scripts.js injects in <head> with defer and runs BEFORE our
    // GSAP scripts (end of <body>, defer) — so at IIFE execution time
    // readyState is 'interactive' and calling initAll synchronously would
    // hit gsap.registerPlugin before gsap is loaded. Only 'complete' means
    // window.load has fired and everything is definitely ready.
    if (document.readyState === 'complete') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    }

    document.addEventListener('shopify:section:load', (e) => {
      if (!e.target) return;
      const section = e.target.classList && e.target.classList.contains('ero-pdp-reviews')
        ? e.target
        : e.target.querySelector && e.target.querySelector('.ero-pdp-reviews');
      if (section) boot(section);
    });

    document.addEventListener('shopify:section:unload', (e) => {
      if (!e.target) return;
      const sec = e.target.classList && e.target.classList.contains('ero-pdp-reviews')
        ? e.target
        : e.target.querySelector && e.target.querySelector('.ero-pdp-reviews');
      if (!sec) return;
      // Revert the matchMedia subscription first so its cleanup function
      // runs and clears the Draggable instance + listeners. Then defensively
      // kill any drag instance that survived (shouldn't, but the explicit
      // kill keeps the section unload path robust against future edits).
      if (typeof sec._pdpReviewsMmRevert === 'function') {
        sec._pdpReviewsMmRevert();
        delete sec._pdpReviewsMmRevert;
      }
      if (sec._dragInstance) {
        sec._dragInstance.kill();
        delete sec._dragInstance;
      }
      delete sec.dataset.pdpRevInit;
      // Stop following the buy box, and make any Loox answer still in
      // flight stale, so nothing touches an unloaded section.
      if (sec._revOnChange) {
        document.removeEventListener('ero:buybox:change', sec._revOnChange);
        delete sec._revOnChange;
      }
      sec._revToken = (sec._revToken || 0) + 1;
      window.clearTimeout(sec._revTimer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-pdp-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* `host` matches the buy box's own entry for a product that is none of
       the three pins, so onBuyBoxChange's accent guard does not reject the
       event and drop the bar's name and prices on such a page. */
    const ACCENTS = {
      br: { color: '#00B8D4', rgb: '0, 184, 212' },
      pm: { color: '#F3A363', rgb: '243, 163, 99' },
      bundle: { color: '#9B6DFF', rgb: '155, 109, 255' },
      host: { color: '#00B8D4', rgb: '0, 184, 212' }
    };

    const money = (cents) => '$' + (Number(cents || 0) / 100).toFixed(2);

    const isActivationKey = (event) => event.key === 'Enter' || event.key === ' ';

    /* The buy box owns flavor, plan, quantity and the savings math. The bar
       reads those surfaces and drives the buy box's own controls rather than
       keeping a second copy of any of them. */
    const buyBoxNode = (selector) => {
      const buyBox = document.querySelector('[data-ero-pdp-buy-box]');
      return buyBox ? buyBox.querySelector(selector) : null;
    };

    const activate = (node) => {
      if (!node) return false;
      node.dispatchEvent(new PointerEvent('pointerup', { bubbles: true }));
      return true;
    };

    /* Most specific first. This is a LOOP rather than one comma-separated
       querySelector on purpose: a selector list resolves by document order,
       not by list order, so a comma list cannot express a preference. The
       shipped footer is `footer.ero-footer` and it is the only entry in
       sections/footer-group.json; the rest are fallbacks in case this bar is
       ever placed on a template that renders Dawn's stock footer. */
    const FOOTER_SELECTORS = ['.ero-footer', '[data-ero-footer]', '.footer', 'footer'];

    const findFooter = () => {
      for (let index = 0; index < FOOTER_SELECTORS.length; index += 1) {
        const node = document.querySelector(FOOTER_SELECTORS[index]);
        if (node) return node;
      }
      return null;
    };

    function updateHeaderCartCount(itemCount) {
      const count = String(itemCount || 0);

      document.querySelectorAll('.ero-nav__cart-badge').forEach((badge) => {
        badge.dataset.count = count;
        badge.textContent = count;
        const link = badge.closest('a');
        if (link) link.setAttribute('aria-label', 'Cart, ' + count + ' items');
      });

      let bubbles = Array.from(document.querySelectorAll('.cart-count-bubble'));
      const cartLink = document.getElementById('cart-icon-bubble');
      if (bubbles.length === 0 && cartLink && itemCount > 0) {
        const bubble = document.createElement('div');
        const visibleCount = document.createElement('span');
        const accessibleCount = document.createElement('span');
        bubble.className = 'cart-count-bubble';
        visibleCount.setAttribute('aria-hidden', 'true');
        accessibleCount.className = 'visually-hidden';
        bubble.append(visibleCount, accessibleCount);
        cartLink.appendChild(bubble);
        bubbles = [bubble];
      }

      bubbles.forEach((bubble) => {
        const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
        const accessibleCount = bubble.querySelector('.visually-hidden');
        if (visibleCount) visibleCount.textContent = count;
        if (accessibleCount) {
          const currentLabel = accessibleCount.textContent || '';
          accessibleCount.textContent = /\d+/.test(currentLabel)
            ? currentLabel.replace(/\d+/, count)
            : count + ' items';
        }
      });
    }

    function refreshCartCount(signal) {
      return fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        signal: signal
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart count refresh failed.');
          return response.json();
        })
        .then((cartData) => {
          updateHeaderCartCount(cartData.item_count);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'pdp-sticky-atc',
              cartData: cartData
            });
          }
        });
    }

    function initRoot(root) {
      if (root._eroStickyAtcCleanup) return;

      /* Portal to body BEFORE observers attach (IT lightbox pattern):
         escapes every scroll-section stacking context so z-index 500 is
         page-level, and body has no transformed ancestor so the ::before
         backdrop-filter stays safe. */
      if (root.parentElement !== document.body) document.body.appendChild(root);

      const controller = new AbortController();
      const signal = controller.signal;
      const timers = [];
      // Both come off the root rather than being hardcoded: the bar rewrites
      // its label after ADDED! and its price on every quantity or plan
      // change, and either would otherwise revert to the bag's strings.
      const FREE_MODE = root.dataset.free === 'true';
      const ATC_LABEL = root.dataset.atcLabel || 'ADD TO BAG';
      /* Variant mode is a DATA switch, not a breakpoint one: there is one
         bar in the DOM and 990+ is CSS over the same nodes, so wiring the
         host product's selected variant here reaches both presentations. */
      const VARIANT_MODE = root.dataset.stickyMode === 'variant';
      const nameNode = root.querySelector('[data-satc-name]');
      const sublineNode = root.querySelector('[data-satc-subline]');
      const planNode = root.querySelector('[data-satc-plan]');
      const priceNode = root.querySelector('[data-satc-price]');
      const compareNode = root.querySelector('[data-satc-compare]');
      const imageNode = root.querySelector('[data-satc-image]');
      const atcButton = root.querySelector('[data-satc-atc]');
      const atcLabels = Array.from(root.querySelectorAll('[data-satc-atc-label]'));
      const toggleButton = root.querySelector('[data-satc-toggle]');
      const panel = root.querySelector('[data-satc-panel]');
      const badgeNode = root.querySelector('[data-satc-badge]');
      const qtyValueNode = root.querySelector('[data-satc-qty-value]');
      const qtyButtons = Array.from(root.querySelectorAll('[data-satc-qty-step]'));
      const flavorPills = Array.from(root.querySelectorAll('[data-satc-flavor]'));
      const planPills = Array.from(root.querySelectorAll('[data-satc-plan-option]'));
      /* Variant-mode panel swatches. The picker snippet's own hook, so this
         reads the same nodes the buy box copy does. Empty in mirror mode. */
      const colorCards = panel ? Array.from(panel.querySelectorAll('[data-color-card]')) : [];
      let mainAtcPassed = false;
      let busy = false;
      let addedTimer = null;
      let atcObserver = null;
      let footerObserver = null;
      let qtyObserver = null;
      let panelOpen = false;
      let footerVisible = false;
      let quantity = 1;
      let unitPrice = Number(root.dataset.satcUnitCents || 0);
      let comparePrice = Number(root.dataset.satcCompareCents || 0);

      /* Price is the LINE TOTAL: unit price times the shared quantity. The
         compare price multiplies the same way so the two read as one row.
         Below 990 the buy box exposes no quantity control and the form
         posts 1, so this resolves to the shipped mobile numbers. */
      function renderPrices() {
        // A free product stays FREE at any quantity: money(0 * n) would read
        // as $0.00, which prices the offer rather than naming it.
        if (priceNode) priceNode.textContent = FREE_MODE ? 'FREE' : money(unitPrice * quantity);
        if (compareNode) compareNode.textContent = FREE_MODE ? '' : money(comparePrice * quantity);
      }

      function renderQuantity() {
        if (qtyValueNode) qtyValueNode.textContent = String(quantity);
        qtyButtons.forEach((button) => {
          if (Number(button.dataset.satcQtyStep) < 0) button.disabled = quantity <= 1;
        });
        renderPrices();
      }

      function renderPanel() {
        const flavor = root.dataset.flavor;
        const plan = root.dataset.plan;

        flavorPills.forEach((pill) => {
          const selected = pill.dataset.satcFlavor === flavor;
          pill.classList.toggle('is-selected', selected);
          pill.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        planPills.forEach((pill) => {
          const selected = pill.dataset.satcPlanOption === plan;
          pill.classList.toggle('is-selected', selected);
          pill.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      }

      /* Mirrors the plan label the buy box renders rather than restating it,
         so a settings change to the subscribe title reaches the bar too. */
      function renderPlanLine() {
        if (!planNode) return;
        const source = root.dataset.plan === 'subscribe'
          ? buyBoxNode('[data-subscribe-title]')
          : buyBoxNode('.bb-onetime__title');
        const label = source ? source.textContent.trim() : '';
        if (label) planNode.textContent = label;
      }

      /* The savings value is READ from the buy box badge, never recomputed:
         one implementation of the MSRP math, in the section that owns it. */
      function renderBadge() {
        if (!badgeNode) return;
        const source = buyBoxNode('[data-bundle-badge]');
        const value = source ? source.textContent.trim() : '';
        badgeNode.textContent = value;
        badgeNode.classList.toggle('is-hidden', !value);
      }

      function readBuyBoxQuantity() {
        const input = buyBoxNode('[data-qty-input]');
        const next = input ? Number(input.value) : quantity;
        return next > 0 && Number.isFinite(next) ? Math.floor(next) : 1;
      }

      function syncQuantity() {
        const next = readBuyBoxQuantity();
        if (next === quantity) return;
        quantity = next;
        renderQuantity();
      }

      function stepQuantity(step) {
        if (step < 0 && quantity <= 1) return;
        const target = buyBoxNode('[data-qty-step="' + step + '"]');
        if (target) {
          activate(target);
          syncQuantity();
          return;
        }
        quantity = Math.max(1, quantity + step);
        renderQuantity();
      }

      /* Reads whatever the buy box is showing right now. Covers the load
         order where the buy box paints and dispatches before this bar has
         attached its listener, and the theme editor reloading either
         section out from under the other. */
      function syncFromBuyBox() {
        const activeFlavor = buyBoxNode('[data-flavor].is-active');
        const flavorKey = activeFlavor ? activeFlavor.dataset.flavor : '';
        if (activeFlavor && ACCENTS[flavorKey]) {
          /* Prices live in the buy box catalog as cents and never reach the
             DOM as numbers, so a bar that reloaded on its own would keep
             Liquid's Blue Raspberry figures while the buy box shows another
             flavor. Re-running the tile's own handler republishes the whole
             detail instead of parsing rendered money strings. On a normal
             load the two already agree, so this never fires and the buy box
             gallery is never rebuilt behind the shopper. */
          if (root.dataset.flavor !== flavorKey) activate(activeFlavor);
          const accent = ACCENTS[flavorKey];
          root.dataset.flavor = flavorKey;
          root.style.setProperty('--ero-accent-color', accent.color);
          root.style.setProperty('--ero-accent-rgb', accent.rgb);
        }

        const activePlan = buyBoxNode('[data-plan].is-selected');
        if (activePlan) {
          root.dataset.plan = activePlan.dataset.plan === 'subscribe' ? 'subscribe' : 'one_time';
        }

        quantity = readBuyBoxQuantity();
        renderQuantity();
        renderPlanLine();
        renderPanel();
        renderBadge();
      }

      /* The buy box owns the selection; this only mirrors it onto the panel,
         which is the same rule the flavor pills follow. */
      function renderColorCards(variantId) {
        if (!colorCards.length || !variantId) return;
        colorCards.forEach(function (card) {
          const selected = String(card.dataset.variantId) === String(variantId);
          card.classList.toggle('is-selected', selected);
          card.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
      }

      function syncColorFromBuyBox() {
        const input = buyBoxNode('[name="id"]');
        if (input && input.value) renderColorCards(input.value);
      }

      function setPanel(open) {
        if (!panel || !toggleButton) return;
        panelOpen = open;
        root.classList.toggle('is-panel-open', open);
        toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) panel.removeAttribute('inert');
        else panel.setAttribute('inert', '');
      }

      function closePanel(returnFocus) {
        if (!panelOpen) return;
        setPanel(false);
        /* preventScroll: nothing in the bar or panel may move the page. */
        if (returnFocus && toggleButton) toggleButton.focus({ preventScroll: true });
      }

      function applyVisibility() {
        const show = mainAtcPassed && !footerVisible;
        root.classList.toggle('is-shown', show);
        if (show) {
          root.removeAttribute('inert');
        } else {
          closePanel(false);
          root.setAttribute('inert', '');
        }
        /* The bar never receives or moves focus on entry. */
      }

      function bindObservers() {
        if (atcObserver) atcObserver.disconnect();
        if (footerObserver) footerObserver.disconnect();
        if (qtyObserver) qtyObserver.disconnect();
        mainAtcPassed = false;
        footerVisible = false;

        const mainAtc = document.querySelector('[data-ero-pdp-buy-box] [data-atc]');
        if (mainAtc) {
          atcObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                mainAtcPassed = false;
              } else {
                /* Directional rule: show only once the ATC has been
                   SCROLLED PAST (sits above the viewport). Below the
                   viewport (unreached, e.g. page load) stays hidden. */
                mainAtcPassed = entry.boundingClientRect.top < 0;
              }
            });
            applyVisibility();
          }, { threshold: 0 });
          atcObserver.observe(mainAtc);
        }

        /* The footer is the only thing that takes the bar back down. The
           moment its top edge enters the viewport the bar leaves, and
           scrolling back up so the footer clears the viewport brings it
           back: isIntersecting is read fresh on every crossing, so the
           rule is symmetric in both directions. Nothing else suppresses
           the bar; it now stays up through the cross-sell. */
        const footer = findFooter();
        if (footer) {
          footerObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              footerVisible = entry.isIntersecting;
            });
            applyVisibility();
          }, { threshold: 0, rootMargin: '0px' });
          footerObserver.observe(footer);
        }

        /* The buy box quantity control publishes no event, so the bar
           watches the value it paints. This is the buy-box-to-bar half of
           the shared quantity; the bar-to-buy-box half drives its buttons. */
        const qtySource = buyBoxNode('[data-qty-value]');
        if (qtySource) {
          qtyObserver = new MutationObserver(syncQuantity);
          qtyObserver.observe(qtySource, { childList: true, characterData: true, subtree: true });
        }

        syncFromBuyBox();
        applyVisibility();
      }

      function onBuyBoxChange(event) {
        const detail = event.detail || {};
        const accent = ACCENTS[detail.key];
        if (!accent) return;

        root.dataset.flavor = detail.key;
        root.dataset.plan = detail.sellingPlanId ? 'subscribe' : 'one_time';
        root.style.setProperty('--ero-accent-color', accent.color);
        root.style.setProperty('--ero-accent-rgb', accent.rgb);

        if (nameNode) nameNode.textContent = detail.flavorLabel || '';
        /* The name stays the product title on both modes; only the second
           line follows the variant. Guarded on a non-empty string so a
           mirror-mode dispatch, which publishes '', cannot blank a subline
           a template set by hand. */
        if (VARIANT_MODE && sublineNode && detail.optionLabel) {
          sublineNode.textContent = detail.optionLabel;
        }
        /* Picking in the buy box updates the panel too, so the two pickers
           never disagree about which colourway is current. */
        renderColorCards(detail.variantId);
        unitPrice = Number(detail.price || 0);
        comparePrice = Number(detail.comparePrice || 0);
        syncQuantity();
        renderPrices();
        renderPlanLine();
        renderPanel();
        renderBadge();
        if (imageNode) {
          if (detail.imageUrl) {
            imageNode.src = detail.imageUrl;
            imageNode.hidden = false;
          } else {
            imageNode.hidden = true;
          }
        }
      }

      function setAdded() {
        atcLabels.forEach((node) => { node.textContent = 'ADDED!'; });
        root.style.setProperty('--satc-boost', '1.4');
        if (addedTimer) window.clearTimeout(addedTimer);
        addedTimer = window.setTimeout(() => {
          atcLabels.forEach((node) => {
            node.textContent = node.dataset.atcLabelText || ATC_LABEL;
          });
          root.style.setProperty('--satc-boost', '1');
        }, 1600);
        timers.push(addedTimer);
      }

      function addToCart() {
        if (busy) return;
        const buyBoxForm = document.querySelector('[data-ero-pdp-buy-box] form.bb-form');
        if (!buyBoxForm) return;
        busy = true;

        /* Same payload the main buy box ATC submits: FormData from the
           buy box form (variant id + quantity + selling_plan; disabled
           selling_plan input is excluded automatically). The quantity in
           that form is the one both quantity controls write. */
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(buyBoxForm),
          signal: signal
        })
          .then((response) => response.json().then((data) => ({ response: response, data: data })))
          .then((result) => {
            if (!result.response.ok || result.data.status) {
              throw new Error(result.data.description || result.data.message || 'Unable to add this item.');
            }
            setAdded();
            return refreshCartCount(signal).catch((error) => {
              if (error.name !== 'AbortError') console.error(error);
            });
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error(error);
          })
          .finally(() => {
            busy = false;
          });
      }

      document.addEventListener('ero:buybox:change', onBuyBoxChange, { signal: signal });

      if (atcButton) {
        atcButton.addEventListener('pointerup', addToCart, { signal: signal });
        atcButton.addEventListener('keydown', (event) => {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          addToCart();
        }, { signal: signal });
      }

      if (toggleButton && panel) {
        const togglePanel = () => setPanel(!panelOpen);
        toggleButton.addEventListener('pointerup', togglePanel, { signal: signal });
        toggleButton.addEventListener('keydown', (event) => {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          togglePanel();
        }, { signal: signal });

        document.addEventListener('pointerdown', (event) => {
          if (!panelOpen) return;
          if (panel.contains(event.target) || toggleButton.contains(event.target)) return;
          closePanel(false);
        }, { signal: signal });

        document.addEventListener('keydown', (event) => {
          if (!panelOpen || event.key !== 'Escape') return;
          event.preventDefault();
          closePanel(true);
        }, { signal: signal });
      }

      qtyButtons.forEach((button) => {
        const step = () => stepQuantity(Number(button.dataset.satcQtyStep));
        button.addEventListener('pointerup', step, { signal: signal });
        button.addEventListener('keydown', (event) => {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          step();
        }, { signal: signal });
      });

      /* Pills are a second view of the buy box tiles, not a second state
         machine: they fire the tile's own handler, and the bar repaints
         from the ero:buybox:change dispatch that follows. */
      flavorPills.forEach((pill) => {
        const choose = () => activate(buyBoxNode('[data-flavor="' + pill.dataset.satcFlavor + '"]'));
        pill.addEventListener('pointerup', choose, { signal: signal });
        pill.addEventListener('keydown', (event) => {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          choose();
        }, { signal: signal });
      });

      planPills.forEach((pill) => {
        const choose = () => {
          /* The buy box names its one-time card "onetime"; Liquid and this
             bar use the "one_time" spelling. */
          const key = pill.dataset.satcPlanOption === 'subscribe' ? 'subscribe' : 'onetime';
          activate(buyBoxNode('[data-plan="' + key + '"]'));
        };
        pill.addEventListener('pointerup', choose, { signal: signal });
        pill.addEventListener('keydown', (event) => {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          choose();
        }, { signal: signal });
      });

      /* Panel swatches drive the BUY BOX picker rather than duplicating its
         logic: _eroSelectColor is the same function its own cards call, so
         price, thumb, gallery and the ero:buybox:change dispatch all follow
         for free, and this bar repaints from that event like any other
         change. Guarded, because the buy box may not have initialised yet
         or may not be in colour mode at all. */
      colorCards.forEach(function (card) {
        const choose = function () {
          if (card.dataset.unavailable === 'true') return;
          const buyBox = document.querySelector('[data-ero-pdp-buy-box]');
          if (!buyBox || typeof buyBox._eroSelectColor !== 'function') return;
          buyBox._eroSelectColor(card.dataset.variantId);
          closePanel(true);
        };
        card.addEventListener('pointerup', choose, { signal: signal });
        card.addEventListener('keydown', function (event) {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          choose();
        }, { signal: signal });
      });

      /* The panel is desktop-only markup; leaving it open across the
         breakpoint would strand an aria-expanded the shopper cannot see. */
      const desktopQuery = window.matchMedia('(min-width: 990px)');
      desktopQuery.addEventListener('change', function () {
        closePanel(false);
      }, { signal: signal });

      syncColorFromBuyBox();

      /* Theme editor: the observed targets in the buy box and the footer
         are replaced on their section reloads; re-bind fresh observers. */
      document.addEventListener('shopify:section:load', () => {
        bindObservers();
      }, { signal: signal });

      bindObservers();

      root._eroStickyAtcCleanup = function () {
        controller.abort();
        if (atcObserver) atcObserver.disconnect();
        if (footerObserver) footerObserver.disconnect();
        if (qtyObserver) qtyObserver.disconnect();
        timers.forEach((timer) => window.clearTimeout(timer));
        delete root._eroStickyAtcCleanup;
        /* The bar was portaled out of its section wrapper, so the theme
           editor's re-render will not remove it; do it here. */
        root.remove();
      };
    }

    function initAll(scope) {
      const context = scope || document;
      if (context.matches && context.matches('[data-ero-sticky-atc]')) initRoot(context);
      context.querySelectorAll('[data-ero-sticky-atc]').forEach(initRoot);
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initAll(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      }, { once: true });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      /* The bar lives on body after the portal, so look it up by the
         unloading section's id rather than inside event.target. */
      const sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      const root = document.querySelector('[data-ero-sticky-atc][data-section-id="' + sectionId + '"]');
      if (root && root._eroStickyAtcCleanup) root._eroStickyAtcCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-reviews-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Live product ids, same as the PDP reviews. Chip order follows this
    // list, then any other product by label, then the store reviews.
    const PRODUCT_LABELS = {
      '8663383998714': 'Blue Raspberry',
      '8663387898106': 'Peach Mango',
      '8674785886458': 'Sample Pack'
    };
    const PRODUCT_ORDER = ['8663383998714', '8663387898106', '8674785886458'];
    const DESKTOP_QUERY = '(min-width: 990px)';

    const COMPARE = {
      newest: (a, b) => b.time - a.time,
      oldest: (a, b) => a.time - b.time,
      high: (a, b) => (b.rating - a.rating) || (b.time - a.time),
      low: (a, b) => (a.rating - b.rating) || (b.time - a.time),
      media: (a, b) => ((b.media ? 1 : 0) - (a.media ? 1 : 0)) || (b.time - a.time)
    };

    const initialsOf = (name) => String(name || '').trim().split(/\s+/).filter(Boolean)
      .slice(0, 2).map((word) => word.charAt(0)).join('').toUpperCase();

    const formatDate = (time) => new Date(time).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });

    // The iframe src comes from Loox data, so only an https url is used.
    const httpsUrl = (value) => {
      try {
        const url = new URL(String(value || ''), window.location.href);
        return url.protocol === 'https:' ? url : null;
      } catch (err) {
        return null;
      }
    };

    // First photo wins; otherwise the first video with a thumbnail.
    const mediaOf = (review) => {
      const items = Array.isArray(review.media) ? review.media : [];
      const photo = items.find((item) => item && item.type === 'photo' && item.url);
      if (photo) return { type: 'photo', src: photo.url };
      const video = items.find((item) => item && item.type === 'video' && item.url && item.thumbnailUrl);
      if (video) return { type: 'video', src: video.thumbnailUrl, video: video.url };
      return null;
    };

    // Store reviews carry only createdAt, product reviews carry date.
    const normalise = (review, isStore, storeLabel) => {
      const product = review.product || {};
      const id = product.id == null ? '' : String(product.id);
      const source = String(review.date || review.createdAt || '');
      const reply = review.reply || {};
      const replyBody = String(reply.body || '').trim();
      const replySource = String(reply.repliedAt || '');
      const rating = Math.round(Number(review.rating) || 0);
      return {
        rating: Math.max(1, Math.min(5, rating)),
        body: String(review.body || '').trim(),
        name: String((review.reviewer && review.reviewer.name) || '').trim(),
        time: Date.parse(source) || 0,
        iso: source,
        key: isStore ? 'store' : id,
        label: isStore ? storeLabel : (PRODUCT_LABELS[id] || product.name || ''),
        verified: review.verified === true,
        media: mediaOf(review),
        reply: replyBody ? { body: replyBody, time: Date.parse(replySource) || 0, iso: replySource } : null,
        node: null
      };
    };

    // textContent and attributes only; review and reply text never go
    // through innerHTML.
    const buildCard = (template, review) => {
      const item = template.content.firstElementChild.cloneNode(true);
      item._eroRv = review;
      const card = item.querySelector('.ero-rv-card');
      const img = item.querySelector('.ero-rv-card__photo');
      const initials = item.querySelector('.ero-rv-card__initials');
      const expand = item.querySelector('[data-expand]');
      const play = item.querySelector('[data-play]');

      if (review.media) {
        img.src = review.media.src;
        initials.remove();
        if (review.media.type === 'video') {
          // The play button names the video, so the thumbnail is decorative.
          img.alt = '';
          expand.remove();
          play.setAttribute('aria-label', 'Play video from ' + review.name);
        } else {
          img.alt = 'Photo from ' + review.name;
          play.remove();
          expand.setAttribute('aria-label', 'Expand media from ' + review.name);
        }
      } else {
        img.remove();
        expand.remove();
        play.remove();
        initials.textContent = initialsOf(review.name);
        initials.setAttribute('aria-label', review.name + ' avatar');
      }

      const stars = item.querySelector('.ero-rv-card__stars');
      const filled = stars.querySelector('[data-star-proto="filled"]');
      const empty = stars.querySelector('[data-star-proto="empty"]');
      const row = [];
      for (let i = 0; i < 5; i += 1) {
        const star = (i < review.rating ? filled : empty).cloneNode(true);
        star.removeAttribute('data-star-proto');
        row.push(star);
      }
      stars.replaceChildren(...row);
      stars.setAttribute('aria-label', 'Rating: ' + review.rating + ' out of 5');

      const date = item.querySelector('.ero-rv-card__date');
      if (review.time) {
        date.setAttribute('datetime', review.iso);
        date.textContent = formatDate(review.time);
      } else {
        date.remove();
      }

      const text = item.querySelector('.ero-rv-card__text');
      if (review.body) {
        text.querySelector('.ero-rv-card__review').textContent = review.body;
      } else {
        text.remove();
      }

      const replyWrap = item.querySelector('.ero-rv-card__reply-wrap');
      if (review.reply) {
        card.classList.add('ero-rv-card--reply');
        const replyDate = replyWrap.querySelector('.ero-rv-reply__date');
        if (review.reply.time) {
          replyDate.setAttribute('datetime', review.reply.iso);
          replyDate.textContent = formatDate(review.reply.time);
        } else {
          replyDate.remove();
        }
        replyWrap.querySelector('.ero-rv-reply__body').textContent = review.reply.body;
      } else {
        replyWrap.remove();
      }

      item.querySelector('.ero-rv-card__name').textContent = review.name;
      item.querySelector('.ero-rv-card__variant').textContent = review.label;
      if (!review.verified) item.querySelector('.ero-rv-card__verified').remove();
      return item;
    };

    const init = (root) => {
      if (root.dataset.eroRvInit === '1') return;
      root.dataset.eroRvInit = '1';

      const controller = new AbortController();
      const signal = controller.signal;
      root._eroRvAbort = controller;

      const q = (selector) => root.querySelector(selector);
      const summaryWrap = q('[data-summary-wrap]');
      const summaryValue = q('[data-summary-value]');
      const summaryStars = q('[data-summary-stars]');
      const starClips = Array.from(root.querySelectorAll('[data-star-clip]'));
      const bars = Array.from(root.querySelectorAll('[data-bar]'));
      const controls = q('[data-controls]');
      const chipList = q('[data-chips]');
      const mediaChip = q('[data-media]');
      const clearButton = q('[data-clear]');
      const sortRoot = q('[data-sort-root]');
      const sortToggle = q('[data-sort-toggle]');
      const sortPanel = q('[data-sort-panel]');
      const sortValue = q('[data-sort-value]');
      const sortOptions = Array.from(root.querySelectorAll('[data-sort-panel] [role="option"]'));
      const listWrap = q('[data-list-wrap]');
      const list = q('[data-list]');
      const status = q('[data-status]');
      const emptyNode = q('[data-empty]');
      const moreWrap = q('[data-more-wrap]');
      const moreButton = q('[data-more]');
      const template = q('template[data-ero-rv-card]');
      const lightbox = q('[data-ero-rv-lightbox]');
      const mediaSlot = lightbox ? lightbox.querySelector('[data-lightbox-media]') : null;
      const nameSlot = lightbox ? lightbox.querySelector('[data-lightbox-name]') : null;
      const variantSlot = lightbox ? lightbox.querySelector('[data-lightbox-variant]') : null;
      const closeButton = lightbox ? lightbox.querySelector('[data-lightbox-close]') : null;
      if (!list || !template) return;

      const pageSize = Math.max(1, parseInt(root.dataset.pageSize, 10) || 25);
      const storeLabel = root.dataset.storeLabel || 'ERO Nutrition';
      const emptyText = root.dataset.emptyText || '';
      const errorText = root.dataset.errorText || '';
      const api = window.EroLoox;

      const state = { product: 'all', stars: 0, media: false, sort: 'newest', shown: pageSize };
      let reviews = [];
      let matches = [];
      let columns = [];
      let placed = 0;
      let summaryToken = 0;
      let sortOpen = false;

      root.classList.add('is-loading');

      // ── Summary ────────────────────────────────────────────
      const paintSummary = (data) => {
        if (!data || !data.distribution || !data.total) return false;
        const rating = Math.max(0, Math.min(5, Number(data.rating) || 0));
        const text = typeof api.formatRating === 'function' ? api.formatRating(rating) : rating.toFixed(1);
        if (summaryValue) summaryValue.textContent = text;
        if (summaryStars) summaryStars.setAttribute('aria-label', 'Rated ' + text + ' out of 5');
        starClips.forEach((rect, index) => {
          const fill = Math.max(0, Math.min(1, rating - index));
          const width = fill >= 1 ? 14 : (fill <= 0 ? 0 : 1.6 + 10.8 * fill);
          rect.setAttribute('width', String(Math.round(width * 1000) / 1000));
        });
        bars.forEach((bar) => {
          const count = Number(data.distribution[bar.dataset.bar]) || 0;
          const fill = bar.querySelector('[data-bar-fill]');
          if (fill) fill.style.width = (count / data.total) * 100 + '%';
          bar.disabled = count === 0;
        });
        if (summaryWrap) summaryWrap.hidden = false;
        return true;
      };

      // 'all' for All, 'store' for the store chip, else the product id.
      // The client caches by path, so revisiting a chip costs nothing. A
      // newer call makes an older answer stale; null keeps the old summary.
      const refreshSummary = (product) => {
        const token = summaryToken + 1;
        summaryToken = token;
        const request = api && typeof api.bottomline === 'function'
          ? Promise.resolve(api.bottomline(product)).catch(() => null)
          : Promise.resolve(null);
        return request.then((data) => {
          if (signal.aborted || token !== summaryToken) return { stale: true, data: null };
          paintSummary(data);
          return { stale: false, data: data };
        });
      };

      // ── Filtering, columns and paging ──────────────────────
      const keep = (review) => (state.product === 'all' || review.key === state.product)
        && (!state.stars || review.rating === state.stars)
        && (!state.media || !!review.media);

      const columnCount = () => parseInt(getComputedStyle(list).getPropertyValue('--ero-rv-cols'), 10) || 1;

      const cardFor = (review) => {
        if (!review.node) review.node = buildCard(template, review);
        return review.node;
      };

      const buildColumns = () => {
        const count = columnCount();
        columns = [];
        for (let i = 0; i < count; i += 1) {
          const column = document.createElement('ul');
          column.className = 'ero-rv-col';
          columns.push(column);
        }
        list.replaceChildren(...columns);
        placed = 0;
      };

      // Each card goes into the shortest column, ties to the leftmost.
      const placeUpTo = (end) => {
        for (; placed < end; placed += 1) {
          let target = columns[0];
          for (let c = 1; c < columns.length; c += 1) {
            if (columns[c].offsetHeight < target.offsetHeight) target = columns[c];
          }
          target.appendChild(cardFor(matches[placed]));
        }
      };

      const updateUi = () => {
        const total = matches.length;
        const showing = Math.min(state.shown, total);
        const done = showing >= total;
        if (status) status.textContent = 'Showing ' + showing + ' of ' + total + ' reviews';
        if (emptyNode) {
          emptyNode.textContent = emptyText;
          emptyNode.hidden = total > 0;
        }
        if (listWrap) listWrap.hidden = total === 0;
        if (moreWrap) {
          moreWrap.hidden = total === 0;
          moreWrap.classList.toggle('is-done', done);
        }
        if (moreButton) moreButton.hidden = done;
        if (chipList) {
          chipList.querySelectorAll('[data-product]').forEach((chip) => {
            chip.setAttribute('aria-pressed', chip.dataset.product === state.product ? 'true' : 'false');
          });
        }
        bars.forEach((bar) => {
          bar.setAttribute('aria-pressed', Number(bar.dataset.bar) === state.stars ? 'true' : 'false');
        });
        if (mediaChip) mediaChip.setAttribute('aria-pressed', state.media ? 'true' : 'false');
        if (clearButton) clearButton.hidden = !(state.product !== 'all' || state.stars || state.media);
      };

      // Every filter or sort change: refilter, back to one page, rebuild.
      // The list is unhidden BEFORE placing, since a hidden column measures 0.
      const render = () => {
        matches = reviews.filter(keep).sort(COMPARE[state.sort] || COMPARE.newest);
        state.shown = pageSize;
        if (listWrap) listWrap.hidden = matches.length === 0;
        buildColumns();
        placeUpTo(Math.min(state.shown, matches.length));
        updateUi();
      };

      // Appends the next page into the shortest columns; cards already
      // showing are not rebuilt.
      const loadMore = () => {
        state.shown += pageSize;
        placeUpTo(Math.min(state.shown, matches.length));
        updateUi();
      };

      // Breakpoint change: new column count, same card nodes, same order.
      const relayout = () => {
        if (!matches.length) return;
        const count = Math.min(state.shown, matches.length);
        buildColumns();
        placeUpTo(count);
      };

      // ── Chips ──────────────────────────────────────────────
      const buildChip = (key, label) => {
        const item = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ero-rv-chip';
        button.dataset.product = key;
        button.setAttribute('aria-pressed', key === state.product ? 'true' : 'false');
        const text = document.createElement('span');
        text.className = 'ero-rv-chip__label';
        text.textContent = label;
        button.appendChild(text);
        item.appendChild(button);
        return item;
      };

      const buildChips = () => {
        if (!chipList) return;
        const labels = new Map();
        reviews.forEach((review) => {
          if (!labels.has(review.key)) labels.set(review.key, review.label);
        });
        const known = PRODUCT_ORDER.filter((key) => labels.has(key));
        const others = Array.from(labels.keys())
          .filter((key) => key !== 'store' && PRODUCT_ORDER.indexOf(key) === -1)
          .sort((a, b) => String(labels.get(a)).localeCompare(String(labels.get(b))));
        const keys = known.concat(others, labels.has('store') ? ['store'] : []);
        chipList.replaceChildren(
          buildChip('all', 'All'),
          ...keys.map((key) => buildChip(key, labels.get(key) || ''))
        );
      };

      // A star filter the new scope has no reviews for is cleared once its
      // counts arrive; the list waits for them so it renders once.
      const selectProduct = (key) => {
        if (key === state.product) return;
        state.product = key;
        updateUi();
        refreshSummary(key).then((result) => {
          if (result.stale) return;
          const counts = result.data && result.data.distribution;
          if (counts && state.stars && !Number(counts[state.stars])) state.stars = 0;
          render();
        });
      };

      const clearFilters = () => {
        const productChanged = state.product !== 'all';
        state.product = 'all';
        state.stars = 0;
        state.media = false;
        if (productChanged) refreshSummary('all');
        render();
        const allChip = chipList && chipList.querySelector('[data-product="all"]');
        if (allChip) allChip.focus({ preventScroll: true });
      };

      if (chipList) {
        chipList.addEventListener('click', (event) => {
          const chip = event.target.closest('[data-product]');
          if (chip) selectProduct(chip.dataset.product);
        }, { signal: signal });
      }

      bars.forEach((bar) => {
        bar.addEventListener('click', () => {
          const level = Number(bar.dataset.bar);
          state.stars = state.stars === level ? 0 : level;
          render();
        }, { signal: signal });
      });

      if (mediaChip) {
        mediaChip.addEventListener('click', () => {
          state.media = !state.media;
          render();
        }, { signal: signal });
      }

      if (clearButton) clearButton.addEventListener('click', clearFilters, { signal: signal });
      if (moreButton) moreButton.addEventListener('click', loadMore, { signal: signal });

      // ── Sort dropdown (buy box frequency pattern) ──────────
      const setSortOpen = (open, returnFocus) => {
        if (!sortRoot || !sortToggle) return;
        sortOpen = !!open;
        sortRoot.classList.toggle('is-open', sortOpen);
        sortToggle.setAttribute('aria-expanded', sortOpen ? 'true' : 'false');
        if (sortOpen) {
          const target = sortOptions.find((option) => option.getAttribute('aria-selected') === 'true') || sortOptions[0];
          if (target) target.focus({ preventScroll: true });
        } else if (returnFocus) {
          sortToggle.focus({ preventScroll: true });
        }
      };

      const chooseSort = (option) => {
        if (!option || !option.dataset.sort) return;
        sortOptions.forEach((item) => {
          const selected = item === option;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.classList.toggle('is-selected', selected);
        });
        if (sortValue) sortValue.textContent = option.textContent.trim();
        setSortOpen(false, true);
        if (option.dataset.sort !== state.sort) {
          state.sort = option.dataset.sort;
          render();
        }
      };

      if (sortToggle) {
        sortToggle.addEventListener('pointerup', () => setSortOpen(!sortOpen, false), { signal: signal });
        sortToggle.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            setSortOpen(true, false);
          } else if (event.key === 'Escape' && sortOpen) {
            event.preventDefault();
            setSortOpen(false, true);
          }
        }, { signal: signal });
      }

      if (sortPanel) {
        sortPanel.addEventListener('pointerup', (event) => {
          chooseSort(event.target.closest('[role="option"]'));
        }, { signal: signal });
        sortPanel.addEventListener('keydown', (event) => {
          if (!sortOptions.length) return;
          const index = sortOptions.indexOf(document.activeElement);
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            sortOptions[Math.min(index + 1, sortOptions.length - 1)].focus({ preventScroll: true });
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            sortOptions[Math.max(index - 1, 0)].focus({ preventScroll: true });
          } else if (event.key === 'Home') {
            event.preventDefault();
            sortOptions[0].focus({ preventScroll: true });
          } else if (event.key === 'End') {
            event.preventDefault();
            sortOptions[sortOptions.length - 1].focus({ preventScroll: true });
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            chooseSort(document.activeElement.closest('[role="option"]'));
          } else if (event.key === 'Escape') {
            event.preventDefault();
            setSortOpen(false, true);
          } else if (event.key === 'Tab') {
            setSortOpen(false, false);
          }
        }, { signal: signal });
      }

      // Outside press closes the panel. On document, removed on unload.
      document.addEventListener('pointerdown', (event) => {
        if (sortOpen && sortRoot && !sortRoot.contains(event.target)) setSortOpen(false, false);
      }, { signal: signal });

      // ── Lightbox (PDP reviews pattern, iframe for video) ───
      const openLightbox = (data) => {
        if (!lightbox || !mediaSlot) return;
        mediaSlot.innerHTML = '';
        if (data.video) {
          const url = httpsUrl(data.video);
          if (!url) return;
          url.searchParams.set('autoplay', 'true');
          const frame = document.createElement('iframe');
          frame.src = url.href;
          frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
          frame.setAttribute('allowfullscreen', '');
          frame.title = 'Video review from ' + data.name;
          mediaSlot.appendChild(frame);
        } else if (data.photo) {
          const img = document.createElement('img');
          img.src = data.photo;
          img.alt = 'Photo from ' + data.name;
          mediaSlot.appendChild(img);
        }
        if (nameSlot) nameSlot.textContent = data.name || '';
        if (variantSlot) variantSlot.textContent = data.variant || '';
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
      };

      // iOS Safari returns focus to the trigger after <dialog> closes and
      // paints a ring on the card. Blur once the close has settled.
      const blurAfterClose = () => {
        requestAnimationFrame(() => {
          if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
        });
      };

      const closeLightbox = () => {
        if (!lightbox) return;
        if (mediaSlot) mediaSlot.innerHTML = '';
        if (typeof lightbox.close === 'function' && lightbox.open) lightbox.close();
        blurAfterClose();
      };

      list.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-expand], [data-play]');
        if (!trigger) return;
        const item = trigger.closest('.ero-rv-item');
        const review = item && item._eroRv;
        if (!review || !review.media) return;
        event.preventDefault();
        openLightbox({
          photo: review.media.type === 'photo' ? review.media.src : '',
          video: review.media.type === 'video' ? review.media.video : '',
          name: review.name,
          variant: review.label
        });
      }, { signal: signal });

      if (closeButton) {
        closeButton.addEventListener('click', (event) => {
          event.preventDefault();
          closeLightbox();
        }, { signal: signal });
      }
      if (lightbox) {
        lightbox.addEventListener('click', (event) => {
          if (event.target === lightbox) closeLightbox();
        }, { signal: signal });
        lightbox.addEventListener('close', () => {
          if (mediaSlot) mediaSlot.innerHTML = '';
          blurAfterClose();
        }, { signal: signal });
      }
      root._eroRvCloseLightbox = closeLightbox;

      const desktop = window.matchMedia(DESKTOP_QUERY);
      if (typeof desktop.addEventListener === 'function') {
        desktop.addEventListener('change', relayout, { signal: signal });
      }

      // ── Load ───────────────────────────────────────────────
      const showError = () => {
        if (summaryWrap) summaryWrap.hidden = true;
        if (controls) controls.hidden = true;
        if (listWrap) listWrap.hidden = true;
        if (moreWrap) moreWrap.hidden = true;
        if (emptyNode) {
          emptyNode.textContent = errorText;
          emptyNode.hidden = false;
        }
        root.classList.remove('is-loading');
      };

      if (!api || typeof api.allProductReviews !== 'function' || typeof api.storeReviews !== 'function') {
        showError();
        return;
      }

      const listOptions = { limit: 250, sort: 'date' };
      const firstSummary = typeof api.bottomline === 'function'
        ? Promise.resolve(api.bottomline('all')).catch(() => null)
        : Promise.resolve(null);

      Promise.all([api.allProductReviews(listOptions), api.storeReviews(listOptions), firstSummary])
        .then(([productList, storeList, summary]) => {
          if (signal.aborted) return;
          if (!Array.isArray(productList) && !Array.isArray(storeList)) {
            showError();
            return;
          }
          reviews = [].concat(
            (productList || []).filter(Boolean).map((review) => normalise(review, false, storeLabel)),
            (storeList || []).filter(Boolean).map((review) => normalise(review, true, storeLabel))
          );
          buildChips();
          if (!paintSummary(summary) && summaryWrap) summaryWrap.hidden = true;
          render();
          root.classList.remove('is-loading');
        })
        .catch(() => {
          if (!signal.aborted) showError();
        });
    };

    const teardown = (root) => {
      if (root._eroRvAbort) {
        root._eroRvAbort.abort();
        delete root._eroRvAbort;
      }
      if (typeof root._eroRvCloseLightbox === 'function') {
        root._eroRvCloseLightbox();
        delete root._eroRvCloseLightbox;
      }
      delete root.dataset.eroRvInit;
    };

    const rootIn = (target) => {
      if (!target) return null;
      if (target.matches && target.matches('[data-ero-rv]')) return target;
      return target.querySelector ? target.querySelector('[data-ero-rv]') : null;
    };

    const initAll = () => {
      document.querySelectorAll('[data-ero-rv]').forEach((root) => init(root));
    };

    // Compiled section scripts run before the deferred assets/ero-loox.js,
    // so the client only exists once DOMContentLoaded fires (it waits for
    // every deferred script).
    if (document.readyState === 'complete') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = rootIn(event.target);
      if (root) init(root);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = rootIn(event.target);
      if (root) teardown(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-sp-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const isActivationKey = (event) => event.key === 'Enter' || event.key === ' ';

    function updateHeaderCartCount(count) {
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
        if (visibleCount) visibleCount.textContent = count;

        const accessibleCount = bubble.querySelector('.visually-hidden');
        if (accessibleCount) {
          const currentLabel = accessibleCount.textContent;
          accessibleCount.textContent = /\d+/.test(currentLabel)
            ? currentLabel.replace(/\d+/, count)
            : count + ' items';
        }
      });
    }

    function refreshCartCount(signal) {
      return fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        signal: signal
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart count refresh failed.');
          return response.json();
        })
        .then((cartData) => {
          updateHeaderCartCount(cartData.item_count);
          // Source is deliberately not 'cart-items': assets/cart.js only
          // reacts to that one, so the drawer stays shut on a cross-sell add.
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sp-cross-sell',
              cartData: cartData
            });
          }
        });
    }

    function addVariant(variantId, signal) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: { _source: 'sp_crosssell' }
            }
          ]
        }),
        signal: signal
      }).then((response) => response.json().then((data) => ({ response: response, data: data })))
        .then((result) => {
          if (!result.response.ok || result.data.status) {
            throw new Error(result.data.description || result.data.message || 'Unable to add this item.');
          }
          return result.data;
        });
    }

    function initRoot(root) {
      if (root.dataset.spXsellInit === '1') return;
      root.dataset.spXsellInit = '1';

      const controller = new AbortController();
      const signal = controller.signal;
      const timers = [];

      const bagCard = root.querySelector('.ero-sp-xsell__card--bag');
      const tiles = Array.from(root.querySelectorAll('[data-flavor][data-variant-id]'));
      const bagCta = root.querySelector('[data-xsell-cta="bag"]');
      const bagPrice = root.querySelector('[data-sp-bag-price]');
      const bagImage = root.querySelector('[data-sp-bag-image]');

      const shakerCard = root.querySelector('.ero-sp-xsell__card--shaker');
      const swatches = Array.from(root.querySelectorAll('.ero-sp-xsell__swatch'));
      const shakerCta = root.querySelector('[data-xsell-cta="shaker"]');
      // Two nodes, one per breakpoint; only one is displayed at a time.
      const shakerPrices = Array.from(root.querySelectorAll('[data-sp-shaker-price]'));
      const shakerImage = root.querySelector('[data-sp-shaker-image]');

      function selectTile(button) {
        tiles.forEach((tile) => {
          const selected = tile === button;
          tile.classList.toggle('is-active', selected);
          tile.setAttribute('aria-checked', selected ? 'true' : 'false');
          tile.setAttribute('aria-pressed', selected ? 'true' : 'false');
          tile.setAttribute('tabindex', selected ? '0' : '-1');
        });
        if (bagCard) bagCard.dataset.flavor = button.dataset.flavor;
        if (bagCta) bagCta.dataset.variantId = button.dataset.variantId;
        if (bagPrice && button.dataset.priceLabel) bagPrice.textContent = button.dataset.priceLabel;
        // srcset first: while a srcset is present, changing src alone does
        // nothing.
        if (bagImage) {
          const src = button.dataset.imageSrc;
          const srcset = button.dataset.imageSrcset;
          const alt = button.dataset.imageAlt;
          if (srcset) bagImage.srcset = srcset;
          if (src) bagImage.src = src;
          if (alt) bagImage.alt = alt;
        }
      }

      tiles.forEach((button) => {
        button.addEventListener('pointerup', () => selectTile(button), { signal: signal });
        button.addEventListener('keydown', (event) => {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          selectTile(button);
        }, { signal: signal });
      });

      function selectSwatch(button) {
        swatches.forEach((swatch) => {
          const selected = swatch === button;
          swatch.classList.toggle('is-selected', selected);
          swatch.setAttribute('aria-checked', selected ? 'true' : 'false');
          swatch.setAttribute('tabindex', selected ? '0' : '-1');
        });

        if (shakerCard) shakerCard.dataset.color = button.dataset.color;
        if (shakerCta) shakerCta.dataset.variantId = button.dataset.variantId;
        if (button.dataset.priceLabel) {
          shakerPrices.forEach((node) => { node.textContent = button.dataset.priceLabel; });
        }

        if (shakerImage && button.dataset.imageSrc) {
          shakerImage.src = button.dataset.imageSrc;
          shakerImage.srcset = button.dataset.imageSrcset || '';
          shakerImage.alt = button.dataset.imageAlt || '';
        }
      }

      swatches.forEach((button) => {
        button.addEventListener('pointerup', () => selectSwatch(button), { signal: signal });
        button.addEventListener('keydown', (event) => {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          selectSwatch(button);
        }, { signal: signal });
      });

      root.querySelectorAll('[data-xsell-cta]').forEach((button) => {
        const label = button.querySelector('[data-xsell-label]');
        const errorNode = button.parentElement.querySelector('[data-xsell-error]');
        const originalLabel = label ? label.textContent : '';
        let busy = false;

        function showError(message) {
          if (!errorNode) return;
          errorNode.textContent = message;
          errorNode.hidden = false;
        }

        function clearError() {
          if (!errorNode) return;
          errorNode.textContent = '';
          errorNode.hidden = true;
        }

        function restoreButton() {
          if (label) label.textContent = originalLabel;
          button.classList.remove('is-added');
          button.removeAttribute('aria-disabled');
          busy = false;
        }

        function fire() {
          const variantId = button.dataset.variantId;
          if (busy || !variantId) return;

          busy = true;
          button.setAttribute('aria-disabled', 'true');
          clearError();

          addVariant(variantId, signal)
            .then(() => {
              button.classList.add('is-added');
              if (label) label.textContent = 'Added ✓';
              refreshCartCount(signal).catch((error) => {
                if (error.name !== 'AbortError') console.error(error);
              });
              timers.push(window.setTimeout(restoreButton, 2200));
            })
            .catch((error) => {
              restoreButton();
              if (error.name === 'AbortError') return;
              const fallback = window.cartStrings && window.cartStrings.error
                ? window.cartStrings.error
                : 'Unable to add this item. Please try again.';
              const message = error.message || fallback;
              showError(message);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'sp-cross-sell',
                  productVariantId: variantId,
                  errors: message,
                  message: message
                });
              }
              console.error('ERO Sample Pack cross-sell add failed.', error);
            });
        }

        button.addEventListener('pointerup', fire, { signal: signal });
        button.addEventListener('keydown', (event) => {
          if (!isActivationKey(event)) return;
          event.preventDefault();
          fire();
        }, { signal: signal });
      });

      root._eroSpXsellCleanup = function () {
        controller.abort();
        timers.forEach((timer) => window.clearTimeout(timer));
        delete root.dataset.spXsellInit;
        delete root._eroSpXsellCleanup;
      };
    }

    function initAll(scope) {
      const context = scope || document;
      if (context.matches && context.matches('[data-ero-sp-xsell]')) initRoot(context);
      context.querySelectorAll('[data-ero-sp-xsell]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches && event.target.matches('[data-ero-sp-xsell]')
        ? event.target
        : event.target.querySelector('[data-ero-sp-xsell]');
      if (root && root._eroSpXsellCleanup) root._eroSpXsellCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ero-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const init = (section) => {
      if (section.dataset.testInit === '1') return;
      section.dataset.testInit = '1';

      const viewport = section.querySelector('[data-viewport]');
      const track = section.querySelector('[data-track]');
      const slides = Array.from(section.querySelectorAll('[data-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-dot]'));
      const prevBtn = section.querySelector('[data-arrow-prev]');
      const nextBtn = section.querySelector('[data-arrow-next]');
      const expandBtns = Array.from(section.querySelectorAll('[data-expand]'));

      if (!track || slides.length === 0) return;
      if (typeof gsap === 'undefined') return;

      const sectionId = section.dataset.sectionId;
      const lightbox = document.querySelector('[data-lightbox="' + sectionId + '"]');
      const mediaSlot = lightbox ? lightbox.querySelector('[data-lightbox-media]') : null;
      const nameSlot = lightbox ? lightbox.querySelector('[data-lightbox-name]') : null;
      const variantSlot = lightbox ? lightbox.querySelector('[data-lightbox-variant]') : null;
      const closeBtn = lightbox ? lightbox.querySelector('[data-lightbox-close]') : null;

      // ──────────────────────────────────────────────────────
      // Lightbox — non-animation UI, lives outside matchMedia.
      // ──────────────────────────────────────────────────────
      const openLightbox = (data) => {
        if (!lightbox || !mediaSlot) return;
        mediaSlot.innerHTML = '';
        if (data.video && data.embed) {
          // Loox video: a Cloudflare Stream player page, so an iframe. Only
          // an https url from the Loox data is used.
          let url = null;
          try {
            url = new URL(data.video, window.location.href);
          } catch (err) {
            url = null;
          }
          if (!url || url.protocol !== 'https:') return;
          url.searchParams.set('autoplay', 'true');
          const frame = document.createElement('iframe');
          frame.src = url.href;
          frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
          frame.setAttribute('allowfullscreen', '');
          frame.title = 'Video review from ' + data.name;
          mediaSlot.appendChild(frame);
        } else if (data.video) {
          const video = document.createElement('video');
          video.src = data.video;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          mediaSlot.appendChild(video);
        } else if (data.photo) {
          const img = document.createElement('img');
          img.src = data.photo;
          img.alt = 'Photo from ' + data.name;
          img.style.maxWidth = '100%';
          img.style.maxHeight = '100%';
          img.style.borderRadius = '10px';
          mediaSlot.appendChild(img);
        }
        if (nameSlot) nameSlot.textContent = data.name || '';
        if (variantSlot) variantSlot.textContent = data.variant || '';
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
      };

      // iOS Safari returns focus to the expand button after <dialog> closes,
      // which renders a focus indicator painted on the ancestor card. Blur
      // after rAF so the dialog close has settled before focus is stripped.
      const blurAfterClose = () => {
        requestAnimationFrame(() => {
          if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
          }
        });
      };

      const closeLightbox = () => {
        if (!lightbox) return;
        const video = mediaSlot ? mediaSlot.querySelector('video') : null;
        if (video) {
          try { video.pause(); } catch (err) { /* noop */ }
        }
        if (mediaSlot) mediaSlot.innerHTML = '';
        if (typeof lightbox.close === 'function') lightbox.close();
        blurAfterClose();
      };

      expandBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openLightbox({
            photo: btn.dataset.photo || '',
            video: btn.dataset.video || '',
            embed: btn.dataset.embed === '1',
            name: btn.dataset.name || '',
            variant: btn.dataset.variant || ''
          });
        });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          closeLightbox();
        });
      }
      if (lightbox) {
        lightbox.addEventListener('click', (e) => {
          if (e.target === lightbox) closeLightbox();
        });
        lightbox.addEventListener('close', () => {
          if (mediaSlot) mediaSlot.innerHTML = '';
          blurAfterClose();
        });
      }

      // ──────────────────────────────────────────────────────
      // Carousel — GSAP Draggable + per-frame scale on mobile;
      // simple arrow-click navigation on desktop. Both buckets
      // live in the same matchMedia instance below.
      // ──────────────────────────────────────────────────────
      const mm = gsap.matchMedia();

      mm.add('(max-width: 989px) and (prefers-reduced-motion: no-preference)', () => {
        // Measure at runtime so carousel geometry respects --u scaling AND
        // the slide's negative margin-right overlap in one shot: step =
        // width + marginRight resolves to 327 + (-48) = 279 at the baseline.
        const firstSlideEl = slides[0];
        const SLIDE_WIDTH = firstSlideEl ? firstSlideEl.offsetWidth : 327;
        const slideMarginRight = firstSlideEl
          ? parseFloat(getComputedStyle(firstSlideEl).marginRight)
          : -48;
        const EFFECTIVE_STEP = SLIDE_WIDTH + slideMarginRight;

        const lastZIndex = new Array(slides.length).fill(null);
        const count = slides.length;
        let currentIndex = 0;

        const SCALE_MIN = 0.9;
        const SCALE_MAX = 1.0;
        const SCALE_RANGE = SCALE_MAX - SCALE_MIN;

        const applyScales = (trackTranslateX, cachedSlideWidth, cachedViewportCenter) => {
          if (!slides.length) return;
          if (typeof trackTranslateX !== 'number') trackTranslateX = gsap.getProperty(track, 'x');
          const slideWidth = cachedSlideWidth !== undefined ? cachedSlideWidth : (slides[0].offsetWidth || SLIDE_WIDTH);
          const slideStep = EFFECTIVE_STEP;
          const firstSlideCenter = track.offsetLeft + slides[0].offsetLeft + slideWidth / 2;
          const viewportCenter = cachedViewportCenter !== undefined
            ? cachedViewportCenter
            : ((viewport && viewport.offsetWidth ? viewport.offsetWidth : window.innerWidth) / 2);
          for (let i = 0; i < slides.length; i++) {
            const slideCenterInTrack = firstSlideCenter + (i * slideStep);
            const slideCenterInViewport = trackTranslateX + slideCenterInTrack;
            const offsetFromCenter = Math.abs(slideCenterInViewport - viewportCenter);
            const normalized = Math.min(1, offsetFromCenter / slideStep);
            const scale = SCALE_MAX - (normalized * SCALE_RANGE);
            slides[i].style.transform = 'scale(' + scale.toFixed(4) + ')';
            slides[i].style.setProperty('--peek-opacity', normalized.toFixed(4));
            const newZ = Math.round(scale * 100);
            if (lastZIndex[i] !== newZ) {
              slides[i].style.zIndex = newZ;
              lastZIndex[i] = newZ;
            }
          }
        };

        const update = (prevIdx) => {
          slides.forEach((slide, i) => {
            if (i === currentIndex) {
              slide.classList.add('active');
              slide.setAttribute('aria-current', 'true');
            } else {
              slide.classList.remove('active');
              slide.removeAttribute('aria-current');
            }
          });

          dots.forEach((dot, i) => {
            if (i === currentIndex) {
              dot.classList.add('active');
              dot.setAttribute('aria-selected', 'true');
            } else {
              dot.classList.remove('active');
              dot.setAttribute('aria-selected', 'false');
            }
          });

          if (prevBtn) {
            if (currentIndex <= 0) prevBtn.setAttribute('disabled', '');
            else prevBtn.removeAttribute('disabled');
          }
          if (nextBtn) {
            if (currentIndex >= count - 1) nextBtn.setAttribute('disabled', '');
            else nextBtn.removeAttribute('disabled');
          }
        };

        const findNearestSnapIndex = (x) => {
          let idx = 0;
          let bestDist = Infinity;
          for (let i = 0; i < snaps.length; i++) {
            const d = Math.abs(x - snaps[i]);
            if (d < bestDist) { bestDist = d; idx = i; }
          }
          return { idx, dist: bestDist };
        };

        let throwSettled = false;
        let dragStartIndex = 0;

        gsap.registerPlugin(Draggable, InertiaPlugin);

        function buildSnaps() {
          const vw = viewport.offsetWidth;
          const trackOffset = track.offsetLeft;
          return slides.map((s) => (vw / 2) - (trackOffset + s.offsetLeft + s.offsetWidth / 2));
        }
        let snaps = buildSnaps();

        gsap.set(track, { x: snaps[0] });
        applyScales();

        const drag = Draggable.create(track, {
          type: 'x',
          inertia: true,
          edgeResistance: 0.85,
          dragResistance: 0.05,
          minimumMovement: 6,
          dragClickables: true,
          bounds: { minX: snaps[snaps.length - 1], maxX: snaps[0] },
          snap: {
            x: function (endValue) {
              var bestIdx = dragStartIndex;
              var bestDist = Math.abs(endValue - snaps[dragStartIndex]);
              var minIdx = Math.max(0, dragStartIndex - 2);
              var maxIdx = Math.min(snaps.length - 1, dragStartIndex + 2);
              for (var i = minIdx; i <= maxIdx; i++) {
                var d = Math.abs(endValue - snaps[i]);
                if (d < bestDist) { bestDist = d; bestIdx = i; }
              }
              return snaps[bestIdx];
            }
          },
          onDragStart: function () {
            throwSettled = false;
            dragStartIndex = currentIndex;
          },
          onDrag: applyScales,
          onThrowUpdate: function () {
            applyScales();
            if (throwSettled) return;
            const x = gsap.getProperty(track, 'x');
            const { idx } = findNearestSnapIndex(x);
            if (idx !== currentIndex) {
              throwSettled = true;
              const prev = currentIndex;
              currentIndex = idx;
              update(prev);
            }
          },
          onThrowComplete: function () {
            const finalX = gsap.getProperty(track, 'x');
            const { idx } = findNearestSnapIndex(finalX);
            if (idx !== currentIndex) {
              const prev = currentIndex;
              currentIndex = idx;
              update(prev);
            } else {
              applyScales();
            }
            throwSettled = true;
          }
        })[0];

        section._dragInstance = drag;

        const goTo = (idx) => {
          if (idx < 0) idx = 0;
          if (idx > count - 1) idx = count - 1;
          const prev = currentIndex;
          currentIndex = idx;
          update(prev);
          gsap.to(track, {
            x: snaps[idx],
            duration: 0.35,
            ease: 'quint.out',
            onUpdate: applyScales
          });
        };

        const goPrev = () => goTo(currentIndex - 1);
        const goNext = () => goTo(currentIndex + 1);

        const onPrevDown = (e) => { e.stopPropagation(); };
        const onNextDown = (e) => { e.stopPropagation(); };
        const onPrevClick = (e) => { e.preventDefault(); goPrev(); };
        const onNextClick = (e) => { e.preventDefault(); goNext(); };
        if (prevBtn) prevBtn.addEventListener('pointerdown', onPrevDown);
        if (nextBtn) nextBtn.addEventListener('pointerdown', onNextDown);
        if (prevBtn) prevBtn.addEventListener('click', onPrevClick);
        if (nextBtn) nextBtn.addEventListener('click', onNextClick);

        const dotHandlers = dots.map((dot) => {
          const onDown = (e) => { e.stopPropagation(); };
          const onClick = (e) => {
            e.preventDefault();
            const idx = parseInt(dot.dataset.index, 10) || 0;
            goTo(idx);
          };
          dot.addEventListener('pointerdown', onDown);
          dot.addEventListener('click', onClick);
          return { dot, onDown, onClick };
        });

        const slideHandlers = slides.map((slide) => {
          const onClick = (e) => {
            const idx = parseInt(slide.dataset.index, 10);
            if (isNaN(idx)) return;
            if (idx !== currentIndex) {
              e.preventDefault();
              goTo(idx);
            }
          };
          slide.addEventListener('click', onClick);
          return { slide, onClick };
        });

        let resizeTimeout;
        const onResize = () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            snaps = buildSnaps();
            drag.applyBounds({ minX: snaps[snaps.length - 1], maxX: snaps[0] });
            drag.vars.snap = {
              x: function (endValue) {
                var bestIdx = dragStartIndex;
                var bestDist = Math.abs(endValue - snaps[dragStartIndex]);
                var minIdx = Math.max(0, dragStartIndex - 2);
                var maxIdx = Math.min(snaps.length - 1, dragStartIndex + 2);
                for (var i = minIdx; i <= maxIdx; i++) {
                  var d = Math.abs(endValue - snaps[i]);
                  if (d < bestDist) { bestDist = d; bestIdx = i; }
                }
                return snaps[bestIdx];
              }
            };
            gsap.set(track, { x: snaps[currentIndex] });
            applyScales();
          }, 150);
        };
        window.addEventListener('resize', onResize, { passive: true });

        const onKeydown = (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); goPrev(); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); }
        };
        if (viewport) viewport.addEventListener('keydown', onKeydown);

        update(-1);

        // matchMedia cleanup runs on viewport cross to desktop.
        // Detach every listener we bound inside this bucket and reset
        // the slide inline styles + track transform so the desktop
        // bucket (empty for now) starts from a clean static layout.
        return () => {
          if (drag) { drag.kill(); section._dragInstance = null; }
          clearTimeout(resizeTimeout);
          window.removeEventListener('resize', onResize);
          if (viewport) viewport.removeEventListener('keydown', onKeydown);
          if (prevBtn) {
            prevBtn.removeEventListener('pointerdown', onPrevDown);
            prevBtn.removeEventListener('click', onPrevClick);
          }
          if (nextBtn) {
            nextBtn.removeEventListener('pointerdown', onNextDown);
            nextBtn.removeEventListener('click', onNextClick);
          }
          dotHandlers.forEach(({ dot, onDown, onClick }) => {
            dot.removeEventListener('pointerdown', onDown);
            dot.removeEventListener('click', onClick);
          });
          slideHandlers.forEach(({ slide, onClick }) => {
            slide.removeEventListener('click', onClick);
          });
          slides.forEach((slide) => {
            slide.style.transform = '';
            slide.style.removeProperty('--peek-opacity');
            slide.style.zIndex = '';
            slide.classList.remove('active');
            slide.removeAttribute('aria-current');
          });
          gsap.set(track, { x: 0 });
        };
      });

      mm.add('(min-width: 990px)', () => {
        // Desktop: simple arrow-click navigation. No Draggable, no scale
        // effects. Track shifts by one card width + gap per click.
        // All 5 cards in DOM, 3 visible at once, overflow hidden on track.

        const count = slides.length;
        let currentIndex = 0;
        const VISIBLE_COUNT = 3;
        const maxIndex = Math.max(0, count - VISIBLE_COUNT);

        // Measure card width + gap at runtime for accurate step
        function getStep() {
          if (slides.length < 2) return slides[0] ? slides[0].offsetWidth : 388;
          return slides[1].offsetLeft - slides[0].offsetLeft;
        }

        function updateArrows() {
          if (prevBtn) prevBtn.removeAttribute('disabled');
          if (nextBtn) nextBtn.removeAttribute('disabled');
        }

        function goTo(idx) {
          if (idx > maxIndex) idx = 0;
          if (idx < 0) idx = maxIndex;
          currentIndex = idx;
          updateArrows();
          gsap.to(track, {
            x: -(getStep() * currentIndex),
            duration: 0.4,
            ease: 'power2.out'
          });
        }

        const onPrevClick = (e) => { e.preventDefault(); goTo(currentIndex - 1); };
        const onNextClick = (e) => { e.preventDefault(); goTo(currentIndex + 1); };
        const onPrevDown = (e) => { e.stopPropagation(); };
        const onNextDown = (e) => { e.stopPropagation(); };

        if (prevBtn) {
          prevBtn.addEventListener('pointerdown', onPrevDown);
          prevBtn.addEventListener('click', onPrevClick);
        }
        if (nextBtn) {
          nextBtn.addEventListener('pointerdown', onNextDown);
          nextBtn.addEventListener('click', onNextClick);
        }

        // Keyboard nav on viewport
        const onKeydown = (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex - 1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex + 1); }
        };
        if (viewport) viewport.addEventListener('keydown', onKeydown);

        // Initialize
        gsap.set(track, { x: 0 });
        updateArrows();

        // Card body click → open lightbox with full review (desktop only).
        // Only on cards where review text overflows (line-clamp truncated).
        var cardClickHandlers = [];
        slides.forEach(function(slide) {
          var card = slide.querySelector('.ero-testimonial-card');
          var cardBody = card ? card.querySelector('.ero-testimonial-card__body') : null;
          var review = card ? card.querySelector('.ero-testimonial-card__review') : null;
          if (!cardBody || !review) return;

          var isOverflowing = review.scrollHeight > review.clientHeight;
          if (!isOverflowing) return;

          cardBody.style.cursor = 'pointer';

          var onClick = function(e) {
            if (e.target.closest('.ero-testimonial-card__expand')) return;
            e.preventDefault();
            e.stopPropagation();

            var reviewerName = card.querySelector('.ero-testimonial-card__reviewer-name');
            var reviewerVariant = card.querySelector('.ero-testimonial-card__variant');

            if (mediaSlot) {
              var fullReview = document.createElement('div');
              fullReview.style.cssText = 'max-width:600px;padding:40px;background:rgba(155,109,255,0.15);border:2px solid #9B6DFF;border-radius:12px;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);font-family:Space Grotesk,sans-serif;font-size:16px;line-height:1.6;color:#fff;';
              fullReview.textContent = review.textContent;
              mediaSlot.innerHTML = '';
              mediaSlot.appendChild(fullReview);
            }
            if (nameSlot) nameSlot.textContent = reviewerName ? reviewerName.textContent : '';
            if (variantSlot) variantSlot.textContent = reviewerVariant ? reviewerVariant.textContent : '';
            if (typeof lightbox.showModal === 'function') lightbox.showModal();
          };

          cardBody.addEventListener('click', onClick);
          cardClickHandlers.push({ cardBody: cardBody, onClick: onClick });
        });

        // Cleanup on breakpoint cross back to mobile
        return () => {
          if (prevBtn) {
            prevBtn.removeEventListener('pointerdown', onPrevDown);
            prevBtn.removeEventListener('click', onPrevClick);
          }
          if (nextBtn) {
            nextBtn.removeEventListener('pointerdown', onNextDown);
            nextBtn.removeEventListener('click', onNextClick);
          }
          if (viewport) viewport.removeEventListener('keydown', onKeydown);
          cardClickHandlers.forEach(function(h) {
            h.cardBody.removeEventListener('click', h.onClick);
            h.cardBody.style.cursor = '';
          });
          gsap.set(track, { x: 0 });
        };
      });

      // Hook so the existing shopify:section:unload listener can revert
      // the matchMedia subscription cleanly when the editor swaps the
      // section out.
      section._testimonialsMmRevert = () => { mm.revert(); };
    };

    // ──────────────────────────────────────────────────────
    // Live Loox reviews (8.2). ERO's best 5-star reviews, product and store
    // merged, replace the manual blocks as cards cloned from the section's
    // data-loox-card-template. The blocks stay as the fallback: Loox off,
    // Loox down, or nothing qualifying all leave them untouched.
    // ──────────────────────────────────────────────────────
    const LOOX_CAP_MS = 2500;
    const LOOX_MAX_CARDS = 12;
    const LOOX_MIN_BODY = 60;
    const LOOX_PRODUCT_LABELS = {
      '8663383998714': 'Blue Raspberry',
      '8663387898106': 'Peach Mango',
      '8674785886458': 'Sample Pack'
    };
    // Reviewers CLAUDE.md never features are dropped by assets/ero-loox.js
    // before any list reaches this section.

    const looxEnabled = (section) => section.dataset.loox !== 'false'
      && !!window.EroLoox
      && typeof window.EroLoox.allProductReviews === 'function'
      && typeof window.EroLoox.storeReviews === 'function';

    // Product list in API order (Loox featured: pinned, then photo reviews,
    // then newest), then the store list in API order. 5 stars, a body of
    // 60+ characters, one card per reviewer, first 12. null when both calls
    // fail; an empty array when nothing qualifies.
    const fetchLooxCards = () => {
      const api = window.EroLoox;
      return Promise.all([
        api.allProductReviews({ limit: 250, sort: 'featured' }),
        api.storeReviews({ limit: 250, sort: 'featured' })
      ]).then((lists) => {
        const productList = Array.isArray(lists[0]) ? lists[0] : null;
        const storeList = Array.isArray(lists[1]) ? lists[1] : null;
        if (!productList && !storeList) return null;
        const merged = (productList || []).map((review) => ({ review: review, store: false }))
          .concat((storeList || []).map((review) => ({ review: review, store: true })));
        const used = new Set();
        const cards = [];
        for (let i = 0; i < merged.length && cards.length < LOOX_MAX_CARDS; i += 1) {
          const review = merged[i].review;
          if (!review || Number(review.rating) !== 5) continue;
          const body = String(review.body || '').trim();
          if (body.length < LOOX_MIN_BODY) continue;
          const name = String((review.reviewer && review.reviewer.name) || '').trim();
          if (!name || used.has(name)) continue;
          used.add(name);
          cards.push({ review: review, store: merged[i].store, body: body, name: name });
        }
        return cards;
      }).catch(() => null);
    };

    const looxInitials = (name) => String(name || '').trim().split(/\s+/).filter(Boolean)
      .slice(0, 2).map((word) => word.charAt(0)).join('').toUpperCase();

    const looxVariant = (card) => {
      if (card.store) return 'ERO Nutrition';
      const product = card.review.product || {};
      return LOOX_PRODUCT_LABELS[String(product.id)] || product.name || '';
    };

    // First photo wins; otherwise the first video with a thumbnail. A video
    // review never shows initials (Taylor's ruling).
    const looxMedia = (review) => {
      const media = Array.isArray(review.media) ? review.media : [];
      const photo = media.find((item) => item && item.type === 'photo' && item.url);
      if (photo) return { type: 'photo', src: photo.url };
      const video = media.find((item) => item && item.type === 'video' && item.url && item.thumbnailUrl);
      if (video) return { type: 'video', src: video.thumbnailUrl, video: video.url };
      return null;
    };

    // The homepage UGC play triangle (.ero-ugc__play-icon).
    const SVG_NS = 'http://www.w3.org/2000/svg';
    const buildPlayIcon = () => {
      const svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('viewBox', '0 0 14 16');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const polygon = document.createElementNS(SVG_NS, 'polygon');
      polygon.setAttribute('points', '0,0 14,8 0,16');
      polygon.setAttribute('fill', 'white');
      svg.appendChild(polygon);
      return svg;
    };

    // textContent and attributes only; review text never goes through
    // innerHTML.
    const buildLooxSlide = (template, card, index) => {
      const slide = template.content.firstElementChild.cloneNode(true);
      slide.dataset.index = String(index);
      slide.classList.toggle('active', index === 0);

      const variant = looxVariant(card);
      const media = looxMedia(card.review);
      const img = slide.querySelector('.ero-testimonial-card__photo');
      const initials = slide.querySelector('.ero-testimonial-card__initials');
      const expand = slide.querySelector('[data-expand]');

      if (media && media.type === 'video') {
        // Thumbnail in the photo slot; the expand button becomes the play
        // badge and opens the Loox player in the lightbox iframe.
        if (img) {
          img.src = media.src;
          img.alt = 'Video from ' + card.name;
        }
        if (initials) initials.remove();
        if (expand) {
          expand.classList.add('ero-testimonial-card__expand--play');
          expand.dataset.photo = '';
          expand.dataset.video = media.video;
          expand.dataset.embed = '1';
          expand.dataset.name = card.name;
          expand.dataset.variant = variant;
          expand.setAttribute('aria-label', 'Play video from ' + card.name);
          const icon = expand.querySelector('.ero-testimonial-card__expand-icon');
          if (icon) icon.replaceChildren(buildPlayIcon());
        }
      } else if (media) {
        if (img) {
          img.src = media.src;
          img.alt = 'Photo from ' + card.name;
        }
        if (initials) initials.remove();
        if (expand) {
          expand.dataset.photo = media.src;
          expand.dataset.video = '';
          expand.dataset.name = card.name;
          expand.dataset.variant = variant;
          expand.setAttribute('aria-label', 'Expand media from ' + card.name);
        }
      } else {
        if (img) img.remove();
        if (expand) expand.remove();
        if (initials) {
          initials.textContent = looxInitials(card.name);
          initials.setAttribute('aria-label', card.name + ' avatar');
        }
      }

      const text = slide.querySelector('.ero-testimonial-card__review');
      if (text) text.textContent = card.body;
      const nameNode = slide.querySelector('.ero-testimonial-card__reviewer-name');
      if (nameNode) nameNode.textContent = card.name;
      const variantNode = slide.querySelector('.ero-testimonial-card__variant');
      if (variantNode) variantNode.textContent = variant;
      // Store reviews carry no verified field, so they never get the badge.
      const badge = slide.querySelector('.ero-testimonial-card__verified-badge');
      if (badge && !(card.store === false && card.review.verified === true)) badge.remove();
      return slide;
    };

    // Same markup and attributes the Liquid dots loop prints.
    const buildLooxDot = (index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ero-testimonials__dot' + (index === 0 ? ' active' : '');
      dot.setAttribute('data-dot', '');
      dot.dataset.index = String(index);
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      dot.setAttribute('aria-label', 'Go to testimonial ' + (index + 1));
      return dot;
    };

    const renderLooxCards = (section, cards) => {
      const template = section.querySelector('template[data-loox-card-template]');
      const track = section.querySelector('[data-track]');
      const dotsWrap = section.querySelector('[data-dots]');
      if (!template || !track || !cards.length) return false;
      track.replaceChildren(...cards.map((card, index) => buildLooxSlide(template, card, index)));
      if (dotsWrap) dotsWrap.replaceChildren(...cards.map((card, index) => buildLooxDot(index)));
      return true;
    };

    // Pending state capped at 2.5s, the same pattern the buy box stars use.
    // Answer first: swap the cards in, then init. Cap first: init on the
    // Liquid blocks, and a later answer replaces them once by reverting the
    // carousel, swapping the cards and dots, and initialising again.
    const boot = (section) => {
      if (!looxEnabled(section)) {
        init(section);
        return;
      }
      if (section._looxBooting) return;
      section._looxBooting = true;
      const token = (section._looxToken || 0) + 1;
      section._looxToken = token;
      let settled = false;

      section.classList.add('is-loox-pending');
      section._looxTimer = window.setTimeout(() => {
        if (settled || section._looxToken !== token) return;
        settled = true;
        section.classList.remove('is-loox-pending');
        init(section);
      }, LOOX_CAP_MS);

      fetchLooxCards().then((cards) => {
        if (section._looxToken !== token) return;
        section._looxBooting = false;
        const hasCards = Array.isArray(cards) && cards.length > 0;

        if (!settled) {
          settled = true;
          window.clearTimeout(section._looxTimer);
          if (hasCards) renderLooxCards(section, cards);
          section.classList.remove('is-loox-pending');
          init(section);
          return;
        }

        // The cap already fired and the blocks are running. Replace once.
        if (!hasCards) return;
        if (typeof section._testimonialsMmRevert === 'function') {
          section._testimonialsMmRevert();
          delete section._testimonialsMmRevert;
        }
        if (section._dragInstance) {
          section._dragInstance.kill();
          delete section._dragInstance;
        }
        delete section.dataset.testInit;
        renderLooxCards(section, cards);
        init(section);
      });
    };

    const initAll = () => {
      document.querySelectorAll('.ero-testimonials').forEach(boot);
    };

    // DCL is guaranteed to fire AFTER all deferred scripts execute, so gsap/
    // Draggable/InertiaPlugin are defined by the time initAll runs. Shopify's
    // compiled scripts.js injects in <head> with defer and runs BEFORE our
    // GSAP scripts (end of <body>, defer) — so at IIFE execution time
    // readyState is 'interactive' and calling initAll synchronously would
    // hit gsap.registerPlugin before gsap is loaded. Only 'complete' means
    // window.load has fired and everything is definitely ready.
    if (document.readyState === 'complete') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    }

    document.addEventListener('shopify:section:load', (e) => {
      if (!e.target) return;
      const section = e.target.classList && e.target.classList.contains('ero-testimonials')
        ? e.target
        : e.target.querySelector && e.target.querySelector('.ero-testimonials');
      if (section) boot(section);
    });

    document.addEventListener('shopify:section:unload', (e) => {
      if (!e.target) return;
      const sec = e.target.classList && e.target.classList.contains('ero-testimonials')
        ? e.target
        : e.target.querySelector && e.target.querySelector('.ero-testimonials');
      if (!sec) return;
      // Revert the matchMedia subscription first so its cleanup function
      // runs and clears the Draggable instance + listeners. Then defensively
      // kill any drag instance that survived (shouldn't, but the explicit
      // kill keeps the section unload path robust against future edits).
      if (typeof sec._testimonialsMmRevert === 'function') {
        sec._testimonialsMmRevert();
        delete sec._testimonialsMmRevert;
      }
      if (sec._dragInstance) {
        sec._dragInstance.kill();
        delete sec._dragInstance;
      }
      delete sec.dataset.testInit;
      // A Loox answer still in flight must not touch an unloaded section.
      sec._looxToken = (sec._looxToken || 0) + 1;
      sec._looxBooting = false;
      window.clearTimeout(sec._looxTimer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
